import { HttpService } from 'src/app/services/http/http.service';
import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, Input, HostListener, ElementRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, of, Subject } from 'rxjs'
import { startWith, map, debounceTime, switchMap } from 'rxjs/operators'
import { MatSnackBar } from '@angular/material/snack-bar'
import { TooltipPosition } from '@angular/material/tooltip';
import { NgSelectModule, NgOption } from '@ng-select/ng-select';
import { Spinkit } from 'ng-http-loader';
import { ToastrService } from 'ngx-toastr'
import { ScrollService } from 'src/app/services/scroll/scroll.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { match } from 'assert';
import { FuzzyService } from 'src/app/services/fuzzy-match/fuzzy.service';
export interface User {
  restaurant_name: string;
  csv_restaurantId: string;
}

export let currentSelectedRestoId
export let currentSelectedRestoName
export let currentSelectedRestoEmail
@Component({
  selector: 'app-claim-buisness',
  templateUrl: './claim-buisness.component.html',
  styleUrls: ['./claim-buisness.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ClaimBuisnessComponent implements OnInit {
  public spinkit = Spinkit;
  myControl = new FormControl();
  filteredOptions: Observable<User[]>;
  claimCondition = 0 // 0: select restaurant, 1: enter email, 2: enter otp, 3: details page
  emailEditText = true
  emailCorrectFlag = true
  emailValue = ''
  selectedResto = []
  restoInfoAvailable = true
  options: User[] = [];
  showErrorMessage = false
  otpValue
  otpData
  restoName = ''

  private inputChanged: Subject<string> = new Subject();
  constructor(
    private changeDetection: ChangeDetectorRef,
    private httpSv: HttpService,
    private _snackBar: MatSnackBar,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private dialog: MatDialog,
    private toster: ToastrService
  ) {
    this.inputChanged.pipe(debounceTime(300)).subscribe(value => {
      this.searchRestaurants(value);
    });
  }

  openStore(url: string) {
    window.open(url, "_blank");
  }
  searchControl = new FormControl();
  filteredRestaurants: Observable<any[]> | undefined;
  googleApiKey = 'AIzaSyBUr4XGytpsx2jfqOYd1Quv5b7igBI5NzA';

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      const payload = params['payload'];
      if (payload) {
        try {
          // 2. Decode base64
          const decodedJson = atob(payload);

          // 3. Parse JSON
          const data = JSON.parse(decodedJson);
          console.log(data)

          let restoId = data.restaurant_id;
          this.preloadingFlag = true
          this.httpSv.getPartialRestoDtls(restoId).subscribe((res: any) => {
            if (res['status'] == 'TRUE') {
              this.preloadingFlag = false

              const tempData = res['result'].data
              this.allRestoOpenAIData = JSON.parse(tempData.data);
              console.log(this.allRestoOpenAIData)
              this.selectedOption = {}
              this.selectedOption.place_id = tempData.place_id
              this.searchText = this.allRestoOpenAIData['Name']
              this.selectedEmailToVerify = tempData.email


              this.router.navigate(['/business/successclaim'], {
                state: {
                  place_id: this.selectedOption?.place_id ?? null,
                  openAiRestoInfo: this.allRestoOpenAIData,
                  restosName: this.searchText,
                  restosEmail: this.selectedEmailToVerify,
                  approvedData: this.approveedData,
                  allowedFlag: true
                },

              })
            } else {
              this.preloadingFlag = false
              this._snackBar.open(res['message'])
              setTimeout(() => {
                this._snackBar.dismiss()
              }, 2000);
            }
          }, err => {
            this.preloadingFlag = false
            this._snackBar.open('Opps! Something went wrong')
            setTimeout(() => {
              this._snackBar.dismiss()
            }, 2000);
          })
          // return
        } catch (e) {
          console.error("Invalid payload:", e);
        }
      } else {
        console.warn("No payload found in the URL.");
      }
    });


    this.filteredDropdwonOptions = this.searchControl.valueChanges.pipe(
      debounceTime(300),
      switchMap(value => this.searchRestaurants(value))
    );


    let partial = this.route.snapshot.queryParamMap.get('part')

    if (partial) {
      this.router.navigate(['/business/successclaim'], {
        state: {
          place_id: this.selectedOption?.place_id ?? null,
          openAiRestoInfo: this.allRestoOpenAIData,
          restosName: this.searchText,
          restosEmail: this.selectedEmailToVerify,
          approvedData: this.approveedData,
          allowedFlag: true
        },

      })
    } else {
      // this.getAllResto()
      this.filteredOptions = this.myControl.valueChanges.pipe(
        startWith(""),
        map(value => (typeof value === "string" ? value : value.name)),
        map(name => (name ? this._filter(name) : this.options.slice()))
      );
    }


  }

  changeEmailFlag: boolean = false
  changeEmail() {
    this.changeEmailFlag = true
  }


  @ViewChild('searchInput') searchInputRef!: ElementRef<HTMLInputElement>;

  searchText = '';
  showDropdown = false;
  selectedIndex = 0;
  filteredDropdwonOptions: any = [];
  selectedOption: any = null;
  preloadingFlag: boolean = false
  emailLoader: boolean = false
  tempArray = ['', '', '']
  onKeyDown(event: KeyboardEvent) {
    if (!this.showDropdown) return;

    if (event.key === 'ArrowDown') {
      this.selectedIndex = (this.selectedIndex + 1) % this.filteredDropdwonOptions.length;
      event.preventDefault();
    } else if (event.key === 'ArrowUp') {
      this.selectedIndex = (this.selectedIndex - 1 + this.filteredDropdwonOptions.length) % this.filteredDropdwonOptions.length;
      event.preventDefault();
    } else if (event.key === 'Enter') {
      this.selectOption(this.selectedIndex == 0 ? { name: this.searchText, place_id: null } : this.filteredDropdwonOptions[this.selectedIndex]);
    }
  }

  selectOption(option: any) {
    this.selectedOption = option;
    this.searchText = option.name;
    this.showDropdown = false;
    this.selectedIndex = 0;

    // ❗ Blur the input to remove focus
    this.searchInputRef.nativeElement.blur();
    this.filteredDropdwonOptions = []
  }

  onContainerClick(event: Event) {
    event.stopPropagation(); // Prevent from closing when clicking inside
  }

  @HostListener('document:click')
  onClickOutside() {
    this.showDropdown = false;
  }


  onInputChange(value: string) {
    this.inputChanged.next(value);
  }



  searchRestaurants(query: string): any {
    // if (!query || typeof(query) != 'string') return of([]);
    // return this.httpSv.getAutoCompleteResto(query).pipe(
    //   map((response:any) => response.restaurants || [])
    // );
    if (!query || typeof (query) != 'string') {
      this.filteredDropdwonOptions = []
      this.selectedIndex = 0;
      this.selectedOption = null;
      this.showDropdown = this.filteredDropdwonOptions.length > 0;
      return
    }
    else {
      this.httpSv.getAutoCompleteResto(query).subscribe((res: any) => {
        this.filteredDropdwonOptions = res.restaurants || []
        this.filteredDropdwonOptions.unshift({ name: '', place_id: null })
        this.selectedIndex = 0;
        this.showDropdown = this.filteredDropdwonOptions.length > 0;
      }, err => {
        this.filteredDropdwonOptions = []
        this.selectedIndex = 0;
        this.showDropdown = this.filteredDropdwonOptions.length > 0;
        this._snackBar.open('Opps! Something went wrong')
        setTimeout(() => {
          this._snackBar.dismiss()
        }, 2000);
      })
    }
  }

  fetchRestaurantDtls() {
    if (!this.selectedOption || !this.searchText || this.searchText == '') return

    if (this.selectedOption.name.toLowerCase() == 'demo restaurant') {
      this.selectedOption.place_id = 'ChIJoWxkA71w2EcRLkVPtYszFfE'
      this.fetchRestaurantDetails(this.selectedOption);
    }
    else {
      this.emailLoader = true
      this.httpSv.checkRestoExists(this.selectedOption.place_id).subscribe((res: any) => {
        this.emailLoader = false
        if (res.status == 'pending') {
          this.dialog.open(DialogClaimCheckComponent, {
            data: `Your listing approval has been claimed by ${res.email} and is under review. You will receive an email once it is approved.`
          });
        } else if (res.status == 'approved') {
          this.claimCondition = 1
          this.allRestoOpenAIData = res.data
          this.approveedData.isApproved = true
          this.approveedData.approved_id = res.claim_approved
          if (res.data['Email address']) {
            if (typeof (res.data['Email address']) == 'object') this.emailToVerify = res.data['Email address']
            else this.emailToVerify.push(res.data['Email address'])
            this.selectedEmailToVerify = this.emailToVerify[0]
          }
        } else {
          this.fetchRestaurantDetails(this.selectedOption);
        }
        this.emailLoader = false
      })
    }
  }

  approveedData = {
    isApproved: false,
    approved_id: null
  }

  displayRestaurantName(restaurant: any): string {
    return restaurant ? restaurant.name : '';
  }

  selectedRestoPlaceId: any;
  allRestoOpenAIData: any
  emailToVerify: any = []
  selectedEmailToVerify: string | null = null
  enterEmail: string | null = null
  enteredOtp: string | null = null
  googlePlaceId: any

  fetchRestaurantDetails(payload: any) {

    if (payload.place_id == null) {
      this.claimCondition = 1
      return
    }
    this.preloadingFlag = true
    this.googlePlaceId = payload
    this.emailToVerify = []
    this.httpSv.getRestoDetailsByAI(payload).subscribe((res: any) => {
      this.preloadingFlag = false
      this.claimCondition = 1
      this.allRestoOpenAIData = res.results
      if (res.results['Email address']) {
        if (typeof (res.results['Email address']) == 'object') this.emailToVerify = res.results['Email address']
        else this.emailToVerify.push(res.results['Email address'])
        this.selectedEmailToVerify = this.emailToVerify[0]
      }
    }, (err:any) => {
      this.preloadingFlag = false
      if(err.error.error == 'timeout') {
        this.toster.info('We couldn’t fetch the data at the moment. Please try again later.', '', { timeOut: 2000 });
      }
      else {
        this.toster.error('Opps! Something went wrong', '', { timeOut: 2000 });
      }
    });


  }
  ngAfterViewInit(): void {

  }
  displayFn = (user?: User) => {
    if (user) {
      this.selectedResto = []
      this.selectedResto.push(user)
      this.changeDetection.detectChanges();
    }
    return user ? user.restaurant_name : undefined;
  }
  returnFn(user?: User): string | undefined {
    return user ? user.csv_restaurantId : undefined;
  }

  private _filter(name: string): User[] {
    const filterValue = name.toLowerCase();
    // console.log(this.options.filter(
    //   option => option.name.toLowerCase().indexOf(filterValue) === 0
    // ))
    let temp = this.options.filter(
      option => option.restaurant_name.toLowerCase().indexOf(filterValue) === 0
    )
    if (temp.length == 0) {
      this.restoInfoAvailable = false
      currentSelectedRestoName = name
      this.selectedResto = []
      this.changeDetection.detectChanges();
    }
    else {
      this.restoInfoAvailable = true
      this.changeDetection.detectChanges();
    }
    return this.options.filter(
      option => option.restaurant_name.toLowerCase().indexOf(filterValue) === 0
    );
  }
  claimFunc() {
    if (!this.selectedRestoPlaceId) {
      currentSelectedRestoName = this.restoName
    }
    this.claimCondition = 1
  }
  addEmailFunc() {
    this.emailEditText = false
    this.emailCorrectFlag = false
    this.emailValue = ''
  }
  onOtpChange(e: any) {
    if (e.length == 4) {
      this.otpValue = e;
      this.verifyOtp(e);
    }
    else if (this.showErrorMessage) {
      this.showErrorMessage = false
    }
  }
  verifyOtp(e: any = null) {
    if (this.enteredOtp.length != 4) return
    if (this.enteredOtp == this.otpData) {
      this.router.navigate(['/business/successclaim'], {
        state: {
          place_id: this.selectedOption?.place_id ?? null,
          openAiRestoInfo: this.allRestoOpenAIData,
          restosName: this.searchText,
          restosEmail: this.selectedEmailToVerify,
          approvedData: this.approveedData,
          allowedFlag: true
        },

      })
    }
    else {
      this._snackBar.open("OTP is not valid")
      setTimeout(() => {
        this._snackBar.dismiss()
      }, 2000);
    }
  }
  resendOtp() {
    this.getOtp()
  }
  getOtp(email: string = null) {
    if (this.changeEmailFlag && !email) {
      this.toster.info('Please Enter Email', '', { timeOut: 2000 });
      return
    }

    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/;

    const cleaned = String(email ?? '').trim().toLowerCase();

    if (this.changeEmailFlag && !emailRegex.test(cleaned)) {
      this.toster.info('Please enter a valid email', '', { timeOut: 2000 });
      return;
    }

    if (!this.selectedEmailToVerify && !email) return
    this.emailLoader = true

    // this.selectedEmailToVerify = 'suryansh@iglulabs.com'

    if (email) this.selectedEmailToVerify = email
    console.log(this.selectedEmailToVerify)
    this.changeDetection.detectChanges();


    // need remove later on
    // this.router.navigate(['/business/successclaim'], {
    //   state: {
    //     place_id: this.selectedOption?.place_id ?? null,
    //     openAiRestoInfo: this.allRestoOpenAIData,
    //     restosName: this.searchText,
    //     restosEmail: this.selectedEmailToVerify,
    //     approvedData: this.approveedData,
    //     allowedFlag: true
    //   },

    // })
    // this.preloadingFlag = false
    // return
    //-----------------------

    this.httpSv.sendOtpByEmail(this.selectedEmailToVerify.trim()).subscribe((res:any) => {
      if (res['status'] == 'TRUE') {
        this.emailLoader = false
        const b64 = res.result.data; // base64 string
        const decodedStr = atob(b64); // -> JSON string (if it was encoded as plain ASCII/UTF-8)
        const decodedObj = JSON.parse(decodedStr);

        console.log(decodedObj) 
        this.otpData = decodedObj.otp;
        // alert(this.otpData)
        // this.otpData = res['result'].data.otp
        this.claimCondition = 2
      }
      else {
        this._snackBar.open(res['message'])
        setTimeout(() => {
          this._snackBar.dismiss()
        }, 2000);
      }
    }, err => {
      this._snackBar.open('Opps! Something went wrong')
      setTimeout(() => {
        this._snackBar.dismiss()
      }, 2000);
    })
  }
  goBackToEmail() {
    this.claimCondition = 1
  }
  goToDetailPage() {
    currentSelectedRestoName = this.restoName
    console.log(currentSelectedRestoName, this.restoName);

    this.router.navigate(['/business/successclaim'], {
      state: {
        place_id: this.selectedOption?.place_id ?? null,
        openAiRestoInfo: this.allRestoOpenAIData,
        restosName: this.searchText,
        restosEmail: this.selectedEmailToVerify,
        approvedData: this.approveedData,
        allowedFlag: true
      },

    })
  }
  getAllResto() {
    this.httpSv.getAllD2Resto().subscribe(res => {
      if (res['status'] == 'TRUE') {
        this.options = res['result'].data
        this.changeDetection.detectChanges();
      }
    })
  }
}


// ---------------------------------------------------------------------
// --------------------------------------------------------------------------
// ------------------------------------------------------------------------------------------------------
// -------------------------------------------------------------------------------------------------------------------


@Component({
  selector: 'app-claim-detail',
  templateUrl: './restoDeatailsEditOrAdd.html',
})
export class RestoClaimDetailsComponent implements OnInit {

  @Input() place_id: null | string = null;
  @Input() openAiRestoInfo: any = null
  @Input() restosName: any = null
  @Input() restosEmail: any = null
  @Input() approvedData: any = null


  apiData: any

  cRestoName: string = ''
  cRestoAbout: string = ''
  cRestoAddress: string = ''
  cRestoPhone: string = ''
  cRestoWebsite: string = ''
  cRestoEmail: string = ''
  cRestoAvgRating: string | null = null
  failToFetchDataFlag: boolean = false

  cIsEditDisabled: boolean = false

  cIsEditDisabledFlag: any = {
    restoDtls: true,
    opCloHr: true,
    cuisine: true,
    dietPref: true,
    category: true,
    spacialOffer: true,
    socialLink: true,
    banner: true,
  }

  loader: boolean = true
  finalLoader: boolean = false
  preloadingFlag: boolean = false
  days = [
    { name: 'Monday', short: 'mon' },
    { name: 'Tuesday', short: 'tue' },
    { name: 'Wednesday', short: 'wed' },
    { name: 'Thursday', short: 'thur' },
    { name: 'Friday', short: 'fri' },
    { name: 'Saturday', short: 'sat' },
    { name: 'Sunday', short: 'sun' },
  ];

  timeData: any = {
    mon: { openHH: '00', openMM: '00', openMead: 'am', closeHH: '00', closeMM: '00', closeMead: 'am', isChecked: false },
    tue: { openHH: '00', openMM: '00', openMead: 'am', closeHH: '00', closeMM: '00', closeMead: 'am', isChecked: false },
    wed: { openHH: '00', openMM: '00', openMead: 'am', closeHH: '00', closeMM: '00', closeMead: 'am', isChecked: false },
    thur: { openHH: '00', openMM: '00', openMead: 'am', closeHH: '', closeMM: '', closeMead: 'am', isChecked: false },
    fri: { openHH: '00', openMM: '00', openMead: 'am', closeHH: '00', closeMM: '00', closeMead: 'am', isChecked: false },
    sat: { openHH: '00', openMM: '00', openMead: 'am', closeHH: '00', closeMM: '00', closeMead: 'am', isChecked: false },
    sun: { openHH: '00', openMM: '00', openMead: 'am', closeHH: '00', closeMM: '00', closeMead: 'am', isChecked: false },
  };

  ngOnInit(): void {
    const s = this.router.getCurrentNavigation()?.extras.state ?? history.state;
    if (sessionStorage.getItem('claimedFlag') == 'true' || !s?.allowedFlag) {
      sessionStorage.removeItem('claimedFlag')
      this.router.navigate(['/business/claim'])
      return
    }


    this.place_id = s?.place_id ?? null;
    this.openAiRestoInfo = s?.openAiRestoInfo ?? null;
    this.restosName = s?.restosName ?? null;
    this.restosEmail = s?.restosEmail ?? null;
    this.approvedData = s?.approvedData ?? null;

    console.log(this.approvedData)

    this.cRestoEmail = this.restosEmail

    if (this.place_id == null && this.openAiRestoInfo == null) {
      this.failToFetchDataFlag = true
      this.cIsEditDisabledFlag = {
        restoDtls: false,
        opCloHr: false,
        cuisine: false,
        dietPref: false,
        category: false,
        spacialOffer: false,
        socialLink: false,
        banner: false,
      }
      this.cIsEditDisabled = false
      this.getCuisine()
      this.getDietPref()
      this.getCategory()
      this.cRestoName = this.restosName
    } else {
      //Open AI Image Creation for banner

      const imgPayload = {
        name: this.openAiRestoInfo['Name'],
        website: this.openAiRestoInfo['Website'],
        place_id: this.place_id
      }

      this.cRestoName = this.openAiRestoInfo['Name']
      this.cRestoAbout = this.openAiRestoInfo['Description']
      this.cRestoAddress = this.openAiRestoInfo['Location']
      this.cRestoPhone = this.openAiRestoInfo['Contact number']
      this.cRestoWebsite = this.openAiRestoInfo['Website']
      this.cRestoAvgRating = this.openAiRestoInfo['Average rating'] ? this.openAiRestoInfo['Average rating'].toString() : null
      // this.cRestoEmail = this.openAiRestoInfo['Email address']

      if (this.openAiRestoInfo['Google Map location']) {
        this.googleMapCon = true
        this.googleMapVal = this.openAiRestoInfo['Google Map location']
      }

      if (this.openAiRestoInfo['Social links']) {
        if (this.openAiRestoInfo['Social links']['Instagram']) {
          this.instagramCon = true
          this.instagramVal = this.openAiRestoInfo['Social links']['Instagram']
        }
        else this.openAiRestoInfo['Social links'] = {
          'Instagram': null,
        }
        if (this.openAiRestoInfo['Social links']['Facebook']) {
          this.facebookCon = true
          this.facebookVal = this.openAiRestoInfo['Social links']['Facebook']
        }
        else this.openAiRestoInfo['Social links'] = {
          'Facebook': null
        }
      }
      else {
        this.openAiRestoInfo['Social links'] = {
          'Instagram': null,
          'Facebook': null
        }
      }

      if (this.openAiRestoInfo['Opening hours']) {
        this.days.forEach((day) => {
          const dayData = this.openAiRestoInfo?.['Opening hours']?.[day.name]?.[0] ?? 'Closed';
          if (dayData == 'Closed') {
            this.timeData[day.short].isChecked = false;
          }
          else if (dayData) {
            this.timeData[day.short].openHH = dayData.openHH;
            this.timeData[day.short].openMM = dayData.openMM;
            this.timeData[day.short].openMead = dayData.openMead.toLowerCase();
            this.timeData[day.short].closeHH = dayData.closeHH;
            this.timeData[day.short].closeMM = dayData.closeMM;
            this.timeData[day.short].closeMead = dayData.closeMead.toLowerCase();
            this.timeData[day.short].isChecked = true;
          }
        })

      }

      if (this.openAiRestoInfo?.['Special offers/events']) {
        let offers = this.openAiRestoInfo?.['Special offers/events']

        if (offers['General']) {
          let txt = offers['General'].join(', ')

          Object.entries(this.spacialOffer).forEach(([day, ele]: any) => {
            ele.flag = true
            ele.value = ele.value ? `${ele.value}, ${txt}` : txt;
          })
        }
        Object.entries(this.spacialOffer).forEach(([day, ele]: any) => {
          if (offers[day] && offers[day].length > 0) {
            ele.flag = true
            ele.value = ele.value ? `${ele.value}, ${offers[day].join(', ')}` : offers[day].join(', ');
          }
        })

      }

      this.getCuisine()
      this.getDietPref()
      this.getCategory()
      if (this.openAiRestoInfo) {
        if (!this.approvedData.isApproved) {
          this.httpSv.getAIImages(imgPayload).subscribe((res: any) => {
            if (res['status']) {
              this.imageSliderSrc = [res.results['slides']['image_url']]
              this.logoSrc = res.results['logo']
              this.openAiRestoInfo['logo'] = res.results['logo']; ``

              this.waitForImagesToLoad(this.imageSliderSrc, this.logoSrc).then(() => {
                this.cIsEditDisabled = true
                this.loader = false
              });
            }
            if (!this.approvedData.isApproved) {
              this.claimResto(true)
            }
          })
        } else {
          this.imageSliderSrc = [this.openAiRestoInfo['featured_image']]
          this.logoSrc = this.openAiRestoInfo['logo'] ? this.openAiRestoInfo['logo'] : '../../../assets/img/713818_3-cropped.svg';
          this.waitForImagesToLoad(this.imageSliderSrc, this.logoSrc).then(() => {
            this.cIsEditDisabled = true
            this.loader = false
          });
        }
      }
      else {
        this.partialClaimSubmit()
      }


      if (currentSelectedRestoEmail) {
        this.readOnlyEmailCondition = true
        this.restoEmail = currentSelectedRestoEmail
      }
      if (currentSelectedRestoName) {
        this.restoName = currentSelectedRestoName
      }
    }

    // setTimeout(() => {
    //   if (this.openAiRestoInfo) {
    //     this.claimResto()
    //   } else {

    //   }
    // }, 0)
  }


  claimId: any

  partialClaimSubmit() {
    const payload = {
      name: this.cRestoName,
      email: this.cRestoEmail,
      data: this.openAiRestoInfo ? JSON.stringify(this.openAiRestoInfo) : null,
      place_id: this.place_id,
    }

    this.httpSv.createPartialData(payload).subscribe((res: any) => {
      if (res['status']) {
        this.claimId = res['result'].data
      }
    })
  }


  waitForImagesToLoad(urls: string[], logoUrl: string): Promise<void> {
    const promises = urls.map(url => {
      return new Promise<void>((resolve) => {
        const img = new Image();
        img.onload = () => resolve();
        img.onerror = () => resolve(); // Resolve even if there's an error to prevent hanging
        img.src = url;
      });
    });


    if (logoUrl) {
      const logoPromise = new Promise<void>((resolve) => {
        const logoImg = new Image();
        logoImg.onload = () => resolve();
        logoImg.onerror = () => {
          this.openAiRestoInfo['logo'] = '../../../assets/img/713818_3-cropped.svg';
          this.logoSrc = '../../../assets/img/713818_3-cropped.svg';
          resolve();
        };
        logoImg.src = logoUrl;
      });
      promises.push(logoPromise);
    }

    return Promise.all(promises).then(() => { });
  }


  enforceTimeLimits(value: string, max: number, day: string, field: string) {
    if (!value) return;

    // Only act when user finishes typing 2 digits
    if (value.length < 2) {
      this.timeData[day][field] = value.replace(/^0+/, ''); // remove leading zeros temporarily
      return;
    }

    let val = parseInt(value, 10);
    if (isNaN(val)) val = 0;
    if (val > max) val = max;
    if (val < 0) val = 0;

    this.timeData[day][field] = val.toString().padStart(2, '0');
  }

  shouldShowClear(day: string) {
    const d = this.timeData[day];
    return d.openHH || d.openMM || d.closeHH || d.closeMM;
  }


  clearTime(day: string) {
    const d = this.timeData[day];
    d.openHH = d.openMM = d.closeHH = d.closeMM = '';
  }

  isPreviousDayFilled(index: number): boolean {
    const prevDayShort = this.days[index - 1].short;
    const prev = this.timeData[prevDayShort];
    return prev.openHH && prev.openMM && prev.closeHH && prev.closeMM;
  }

  copyFromPreviousDay(index: number) {
    const prev = this.timeData[this.days[index - 1].short];
    const current = this.timeData[this.days[index].short];
    current.openHH = prev.openHH;
    current.openMM = prev.openMM;
    current.openMead = prev.openMead;
    current.closeHH = prev.closeHH;
    current.closeMM = prev.closeMM;
    current.closeMead = prev.closeMead;
  }



  turnOnEdit(type: string) {
    if (!this.cIsEditDisabledFlag[type]) return
    else this.cIsEditDisabledFlag[type] = false
  }

  cancelEdit(type: string) {

    if (type == 'restoDtls') {
      this.cRestoAbout = this.openAiRestoInfo['Description']
      this.cRestoAddress = this.openAiRestoInfo['Location']
      this.cRestoPhone = this.openAiRestoInfo['Contact number']
      this.cRestoWebsite = this.openAiRestoInfo['Website']
      this.cRestoAvgRating = this.openAiRestoInfo['Average rating']
      //TODO
      this.logoSrc = this.openAiRestoInfo['logo']
      if (this.openAiRestoInfo['logo'].includes('https://logo.clearbit.com/')) {
        this.logoFileData = null;
      }
    }

    else if (type == 'opCloHr') {
      this.days.forEach((day) => {
        const dayData = this.openAiRestoInfo['Opening hours'][day.name][0];
        if (dayData == 'Closed') {
          this.timeData[day.short].isChecked = false;
          this.timeData[day.short].openHH = ''
          this.timeData[day.short].openMM = ''
          this.timeData[day.short].openMead = 'am'
          this.timeData[day.short].closeHH = ''
          this.timeData[day.short].closeMM = ''
          this.timeData[day.short].closeMead = 'am'
        }
        else if (dayData) {
          this.timeData[day.short].openHH = dayData.openHH;
          this.timeData[day.short].openMM = dayData.openMM;
          this.timeData[day.short].openMead = dayData.openMead.toLowerCase();
          this.timeData[day.short].closeHH = dayData.closeHH;
          this.timeData[day.short].closeMM = dayData.closeMM;
          this.timeData[day.short].closeMead = dayData.closeMead.toLowerCase();
          this.timeData[day.short].isChecked = true;
        }
      })
    }
    else if (type == 'cuisine') {
      this.selectedCuisine = []
      this.openAiRestoInfo['Cuisine'].forEach(element => {
        let reCIndex = this.allCuisine.findIndex(ele => ele.name.toLowerCase() == element.toLowerCase())

        if (reCIndex != -1) {
          this.selectedCuisine.push(this.allCuisine[reCIndex].id)
        }
      })
    }

    else if (type == 'dietPref') {
      this.selectedDieatry = []
      console.log(this.openAiRestoInfo['Dietary Preference'])
      this.openAiRestoInfo['Dietary Preference'].forEach(element => {
        let reCIndex = this.allDieatary.findIndex(ele => ele.name.toLowerCase() == element.toLowerCase() || ele.name.toLowerCase() + 'options' == element.toLowerCase() || ele.name.toLowerCase() + 'option' == element.toLowerCase())

        if (reCIndex != -1) {
          this.selectedDieatry.push(this.allDieatary[reCIndex].id)
        }
      })
    }
    else if (type == 'category') {
      this.selectedCaategory = []
      this.openAiRestoInfo['Food Categories'].forEach(element => {
        let reCIndex = this.allCaategory.findIndex(ele => ele.category_name.toLowerCase() == element.toLowerCase())

        if (reCIndex != -1) {
          this.selectedCaategory.push(this.allCaategory[reCIndex].category_id)
        }
      })

    }
    else if (type == 'spacialOffer') {
      if (this.openAiRestoInfo?.['Special offers/events']) {
        let offers = this.openAiRestoInfo?.['Special offers/events']

        this.spacialOffer = {
          "Monday": { 'flag': false, 'value': null },
          "Tuesday": { 'flag': false, 'value': null },
          "Wednesday": { 'flag': false, 'value': null },
          "Thursday": { 'flag': false, 'value': null },
          "Friday": { 'flag': false, 'value': null },
          "Saturday": { 'flag': false, 'value': null },
          "Sunday": { 'flag': false, 'value': null }
        }

        if (offers['General']) {
          let txt = offers['General'].join(', ')

          Object.entries(this.spacialOffer).forEach(([day, ele]: any) => {
            ele.flag = true
            ele.value = ele.value ? `${ele.value}, ${txt}` : txt;
          })
        }
        Object.entries(this.spacialOffer).forEach(([day, ele]: any) => {
          if (offers[day]) {
            ele.flag = true
            ele.value = ele.value ? `${ele.value}, ${offers[day].join(', ')}` : offers[day].join(', ');
          }
        })

      }

    }
    else if (type == 'socialLink') {
      this.googleMapVal = this.openAiRestoInfo?.['Google Map location'] || '';
      this.googleMapCon = !!this.googleMapVal;

      this.instagramVal = this.openAiRestoInfo?.['Social links']?.['Instagram'] || '';
      this.instagramCon = !!this.instagramVal;

      this.facebookVal = this.openAiRestoInfo?.['Social links']?.['Facebook'] || '';
      this.facebookCon = !!this.facebookVal;

    }
    else if (type == 'banner') {

    }
    this.cIsEditDisabledFlag[type] = true
  }

  saveEdit(type: string) {

    if (type == 'restoDtls') {
      this.openAiRestoInfo['Description'] = this.cRestoAbout
      this.openAiRestoInfo['Location'] = this.cRestoAddress
      this.openAiRestoInfo['Contact number'] = this.cRestoPhone
      this.openAiRestoInfo['Website'] = this.cRestoWebsite
      this.openAiRestoInfo['Average rating'] = this.cRestoAvgRating
      //TODO
      this.openAiRestoInfo['logo'] = this.logoSrc
    }

    else if (type == 'opCloHr') {
      this.openAiRestoInfo['Opening hours'] = {}
      this.days.forEach((day) => {
        let dayData = {}
        if (!this.timeData[day.short].isChecked) {
          dayData = 'Closed';
          this.timeData[day.short].openHH = ''
          this.timeData[day.short].openMM = ''
          this.timeData[day.short].openMead = 'am'
          this.timeData[day.short].closeHH = ''
          this.timeData[day.short].closeMead = 'am'
        }
        else if (dayData) {
          dayData['openHH'] = this.timeData[day.short].openHH
          dayData['openMM'] = this.timeData[day.short].openMM
          dayData['openMead'] = this.timeData[day.short].openMead
          dayData['closeHH'] = this.timeData[day.short].closeHH
          dayData['closeMM'] = this.timeData[day.short].closeMM
          dayData['closeMead'] = this.timeData[day.short].closeMead
        }
        this.openAiRestoInfo['Opening hours'][day.name] = [dayData]
      })
    }
    else if (type == 'cuisine') {
      this.openAiRestoInfo['Cuisine'] = []
      this.selectedCuisine.forEach(element => {
        let reCIndex = this.allCuisine.findIndex(ele => ele.id == element)

        if (reCIndex != -1) {
          this.openAiRestoInfo['Cuisine'].push(this.allCuisine[reCIndex].name)
        }
      })
    }

    else if (type == 'dietPref') {
      this.openAiRestoInfo['Dietary Preference'] = []
      this.selectedDieatry.forEach(element => {
        let reCIndex = this.allDieatary.findIndex(ele => ele.id == element)

        if (reCIndex != -1) {
          this.openAiRestoInfo['Dietary Preference'].push(this.allDieatary[reCIndex].name)
        }
      })
    }
    else if (type == 'category') {
      this.openAiRestoInfo['Food Categories'] = []
      this.selectedCaategory.forEach(element => {
        let reCIndex = this.allCaategory.findIndex(ele => ele.category_id == element)

        if (reCIndex != -1) {
          this.openAiRestoInfo['Food Categories'].push(this.allCaategory[reCIndex].category_name)
        }
      })

    }
    else if (type == 'spacialOffer') {

      this.openAiRestoInfo['Special offers/events'] = [];
      Object.entries(this.spacialOffer).forEach(([day, ele]: any) => {
        if (ele.flag && ele.value) {
          this.openAiRestoInfo['Special offers/events'][day] = ele.value.split(',').map((item: string) => item.trim());
        }
      })


    }
    else if (type == 'socialLink') {
      this.openAiRestoInfo['Google Map location'] = this.googleMapCon ? this.googleMapVal || null : null;



      this.openAiRestoInfo['Social links']['Instagram'] = this.instagramCon ? this.instagramVal || null : null;

      this.openAiRestoInfo['Social links']['Facebook'] = this.facebookCon ? this.facebookVal || null : null;

    }
    else if (type == 'banner') {

    }
    this.cIsEditDisabledFlag[type] = true


  }

  firstClaim_id: any
  claimResto(flag: boolean = false) {
    let payload = new FormData();
    if (!this.cRestoName || this.cRestoName == '') {
      this.toster.info('Please enter restaurant name', '', { timeOut: 2000 });
      return
    }
    payload.append('restaurant_name', this.cRestoName.replace(/\b\p{L}/gu, ch => ch.toLocaleUpperCase()));

    if (!this.cRestoEmail || this.cRestoEmail == '') {
      this.toster.info('Please enter restaurant email', '', { timeOut: 2000 });
      return
    }
    payload.append('email', this.cRestoEmail);

    if ((!this.cRestoPhone || this.cRestoPhone == '') && !flag) {
      this.toster.info('Please enter restaurant phone number', '', { timeOut: 2000 });
      return
    }
    payload.append('phone', this.cRestoPhone);

    if (!this.cRestoAddress || this.cRestoAddress == '') {
      this.toster.info('Please enter restaurant address', '', { timeOut: 2000 });
      return
    }
    payload.append('address', this.cRestoAddress);

    if ((!this.cRestoWebsite || this.cRestoWebsite == '') && !flag) {
      this.toster.info('Please enter restaurant website', '', { timeOut: 2000 });
      return
    }
    payload.append('website', this.cRestoWebsite);

    if ((!this.cRestoAbout || this.cRestoAbout == '') && !flag) {
      this.toster.info('Please enter restaurant about', '', { timeOut: 2000 });
      return
    }
    payload.append('about', this.cRestoAbout);

    if (!this.logoFileData && (!this.logoSrc.includes('https://logo.clearbit.com/') && !this.logoSrc.includes('https://foodbud-testing.s3-ap-southeast')) && !flag) {
      this.toster.info('Please upload restaurant logo', '', { timeOut: 2000 });
      return
    }
    payload.append('logo', this.logoFileData ? this.logoFileData : this.logoSrc);

    if (!this.openingClosingValidation()) {
      this.toster.info('Please enter opening and closing hours', '', { timeOut: 2000 });
      return
    }

    let openCloseTime = {};
    this.days.forEach((day) => {
      const dayData = this.timeData[day.short];
      if (dayData.isChecked) {
        openCloseTime[day.name] = [{
          openHH: dayData.openHH,
          openMM: dayData.openMM,
          openMead: dayData.openMead,
          closeHH: dayData.closeHH,
          closeMM: dayData.closeMM,
          closeMead: dayData.closeMead
        }]
      }
      else {
        openCloseTime[day.name] = 'Closed'
      }
    })
    payload.append('open_close_time', JSON.stringify(openCloseTime));

    if (this.selectedCuisine.length > 0) {
      let cIds = []
      this.selectedCuisine.forEach(element => {
        let reCIndex = this.allCuisine.findIndex(ele => ele.id == element)
        if (reCIndex != -1) {
          cIds.push(this.allCuisine[reCIndex].id)
        }
      })
      payload.append('cuisine', cIds.join(','));
    }

    if (this.selectedDieatry.length > 0) {
      let dIds = []
      this.selectedDieatry.forEach(element => {
        let reCIndex = this.allDieatary.findIndex(ele => ele.id == element)
        if (reCIndex != -1) {
          dIds.push(this.allDieatary[reCIndex].id)
        }
      })
      payload.append('dietary', dIds.join(','));
    }

    if (this.selectedCaategory.length > 0) {
      let cIds = []
      this.selectedCaategory.forEach(element => {
        let reCIndex = this.allCaategory.findIndex(ele => ele.category_id == element)
        if (reCIndex != -1) {
          cIds.push(this.allCaategory[reCIndex].category_id)
        }
      })
      payload.append('category', cIds.join(','));
    }

    if (this.spacialOffer) {
      let spacialOffer = {};
      Object.entries(this.spacialOffer).forEach(([day, ele]: any) => {
        spacialOffer[day] = ele.value;
      })
      payload.append('spacial_offer', JSON.stringify(spacialOffer));
    }
    else {
      payload.append('spacial_offer', null);
    }

    payload.append('average_rating', this.cRestoAvgRating ? this.cRestoAvgRating : null);


    if (this.featureImageFile) {
      payload.append('banner_img_1', this.featureImageFile);
    }
    else {
      payload.append('banner_img_1', this.imageSliderSrc[0]);
    }


    console.log(this.imageSliderSrc, this.featureImageFile)

    payload.append('banner_img_2', null);
    payload.append('banner_img_3', null);
    payload.append('is_google', '0');
    payload.append('is_open_ai', '0');
    payload.append('partial_id', this.claimId);
    payload.append('place_id', this.place_id);



    if (this.googleMapCon) {
      payload.append('google_map', this.googleMapVal);
    }
    else {
      payload.append('google_map', null);
    }
    if (this.instagramCon) {
      payload.append('instagram', this.instagramVal);
    }
    else {
      payload.append('instagram', null);
    }
    if (this.facebookCon) {
      payload.append('facebook', this.facebookVal);
    }
    else {
      payload.append('facebook', null);
    }

    for (let [key, value] of (payload as any).entries()) {
      console.log(`${key}:`, value);
    }
    if (!flag) {
      this.preloadingFlag = true
      if (this.approvedData.isApproved)
        payload.append('approved_id', this.approvedData.approved_id);
      else
        payload.append('claim_id', this.firstClaim_id);
    }
    this.httpSv.claimSubmit(payload).subscribe(res => {
      if (res['status'] == 'TRUE') {
        this.imgurl = res['result'].qr
        // this.finalLoader = true
        this.preloadingFlag = false
        if (!flag) {
          this.router.navigate(
            ['/business/successupdate'],
            { state: { imgUrl: this.imgurl, isApproved: this.approvedData.isApproved } }
          )
        }
        else {
          this.firstClaim_id = res['result'].data.claim_id
        }
      }
    })



  }




  openingClosingValidation(): boolean {
    const days = ['mon', 'tue', 'wed', 'thur', 'fri', 'sat', 'sun'];

    for (const day of days) {
      const data = this.timeData[day];
      if (data.isChecked) {
        const allFieldsFilled =
          data.openHH?.toString().trim().length > 0 &&
          data.openMM?.toString().trim().length > 0 &&
          data.closeHH?.toString().trim().length > 0 &&
          data.closeMM?.toString().trim().length > 0;

        if (!allFieldsFilled) {
          return false;
        }
      }
    }

    return true;
  }





  logoSrc: any = '../../../assets/img/713818_3-cropped.svg'
  logoFileData: any = null

  onLogoChange(event: any) {
    let file: File = event.target.files[0];
    // Check if file exists
    if (!file) return;

    // Check if the file size is less than 500KB
    if (file.size > 512000) {
      this.toster.info('Image size should be less than 500KB.', '', { timeOut: 2000 });
      return;
    }
    this.logoFileData = file;
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (e: any) => {
      this.logoSrc = e.target.result;
    };
  }


  onBannerChange(event: any) {
    let file: File = event.target.files[0];
    // Check if file exists
    if (!file) return;
    // Check if the file size is less than 500KB
    if (file.size > 512000) {
      this.toster.info('Image size should be less than 500KB.', '', { timeOut: 2000 });
      return;
    }
    this.featureImageFile = file;
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (e: any) => {
      this.imageSliderSrc = [e.target.result];
      this.changeDetection.detectChanges();
    }
  }

  imgurl: any
  downLoadQrWeb(flag: boolean = false) {
    if (this.imgurl) {
      if (flag) {
        this.imgurl = this.imgurl.replace('www/qr', 'www/qr/qr_codes');
      }

      const imgName = this.imgurl.substr(this.imgurl.lastIndexOf("/") + 1);
      this.preloadingFlag = true
      this.httpClient
        .get(this.imgurl, { responseType: "blob" as "json" })
        .subscribe((res: any) => {
          const file = new Blob([res], { type: res.type });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file);
            return;
          }
          this.preloadingFlag = false
          const blob = window.URL.createObjectURL(file);
          const link = document.createElement("a");
          link.href = blob;
          link.download = imgName;
          link.dispatchEvent(
            new MouseEvent("click", {
              bubbles: true,
              cancelable: true,
              view: window,
            })
          );
          setTimeout(() => {
            window.URL.revokeObjectURL(blob);
            link.remove();
          }, 100);
        }, err => {
          this.preloadingFlag = false
          this.toster.error('Error downloading QR code', '', { timeOut: 2000 });
        });
    }

  }


  readOnlyEmailCondition = false
  positionOptions: TooltipPosition[] = ['below', 'above', 'left', 'right'];
  position = new FormControl(this.positionOptions[0]);
  selctedName = currentSelectedRestoName
  selctedEmail = currentSelectedRestoEmail
  allDieatary = [];
  allAllergens = []
  allCaategory = []
  allCuisine = []
  selectedCityIds: string[];
  selectedDieatry = []
  selectedAllegens = []
  selectedCaategory = []
  selectedCuisine = []
  uniqueId: any


  constructor(
    private _snackBar: MatSnackBar,
    private httpSv: HttpService,
    private toster: ToastrService,
    private scroll: ScrollService,
    private route: ActivatedRoute,
    private changeDetection: ChangeDetectorRef,
    private httpClient: HttpClient,
    private fuzzyMatch: FuzzyService,
    private router: Router
  ) { }

  imageSliderSrc: string[] = []
  featureImageFile: any = null;


  imageIndex: number = 0
  intervalId: any;

  ngAfterViewInit() {
    this.startAutoSlide();
  }

  startAutoSlide() {
    this.intervalId = setInterval(() => {
      this.imageIndex = this.imageSliderSrc.length > 0 ? ((this.imageIndex + 1) % this.imageSliderSrc.length) : 0;
      this.changeDetection.detectChanges();
    }, 6000);
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
  }



  convertTimeTo12HourFormat(time: string) {
    let hours = parseInt(time.substring(0, 2));
    let minutes = time.substring(2);
    let meridian = hours >= 12 ? 'pm' : 'am';

    if (hours > 12) {
      hours -= 12;
    } else if (hours === 0) {
      hours = 12;
    }

    return { hours: hours.toString(), minutes, meridian };
  }

  populateOpeningHours(data: any) {
    const daysMap = ['sun', 'mon', 'tue', 'wed', 'thur', 'fri', 'sat'];

    // Reset all days to closed by default
    daysMap.forEach(day => {
      this[`${day}ClearCondition`] = false;
    });

    let dayWiseTimings: { [key: string]: { open: string, close: string } } = {};

    // Process each opening period
    data.periods.forEach(period => {
      let dayPrefix = daysMap[period.open.day];

      if (!dayWiseTimings[dayPrefix]) {
        dayWiseTimings[dayPrefix] = {
          open: period.open.time,
          close: period.close.time
        };
      } else {
        // Update the earliest opening time
        if (period.open.time < dayWiseTimings[dayPrefix].open) {
          dayWiseTimings[dayPrefix].open = period.open.time;
        }
        // Update the latest closing time
        if (period.close.time > dayWiseTimings[dayPrefix].close) {
          dayWiseTimings[dayPrefix].close = period.close.time;
        }
      }
    });

    // Assign the calculated values to your predefined variables
    Object.keys(dayWiseTimings).forEach(dayPrefix => {
      let openTime = this.convertTimeTo12HourFormat(dayWiseTimings[dayPrefix].open);
      let closeTime = this.convertTimeTo12HourFormat(dayWiseTimings[dayPrefix].close);

      this[`${dayPrefix}OpenHH`] = openTime.hours;
      this[`${dayPrefix}OpenMM`] = openTime.minutes;
      this[`${dayPrefix}OpenMead`] = openTime.meridian;

      this[`${dayPrefix}CloseHH`] = closeTime.hours;
      this[`${dayPrefix}CloseMM`] = closeTime.minutes;
      this[`${dayPrefix}CloseMead`] = closeTime.meridian;

      this[`${dayPrefix}ClearCondition`] = true;
    });
  }

  openLink(link: string) {
    if (link && link.trim() !== '') {
      window.open(link, '_blank');
    }
  }

  last = false
  monClearCondition = true
  tueClearCondition = true
  wedClearCondition = true
  thurClearCondition = true
  friClearCondition = true
  satClearCondition = true
  sunClearCondition = true

  monOpenHH: string = ''
  monOpenMM: string = ''
  monOpenMead: string = 'am'
  monPrecheck
  monCloseHH: string = ''
  monCloseMM: string = ''
  monCloseMead: string = 'am'
  tueOpenHH = ''
  tueOpenMM = ''
  tueOpenMead = 'am'
  tueCloseHH = ''
  tueCloseMM = ''
  tueCloseMead = 'am'
  tuePrecheck
  wedOpenHH = ''
  wedOpenMM = ''
  wedOpenMead = 'am'
  wedCloseHH = ''
  wedCloseMM = ''
  wedCloseMead = 'am'
  wedPrecheck
  thurOpenHH = ''
  thurOpenMM = ''
  thurOpenMead = 'am'
  thurCloseHH = ''
  thurCloseMM = ''
  thurCloseMead = 'am'
  thurPrecheck
  friOpenHH = ''
  friOpenMM = ''
  friOpenMead = 'am'
  friCloseHH = ''
  friCloseMM = ''
  friCloseMead = 'am'
  friPrecheck
  satOpenHH = ''
  satOpenMM = ''
  satOpenMead = 'am'
  satCloseHH = ''
  satCloseMM = ''
  satCloseMead = 'am'
  satPrecheck
  sunOpenHH = ''
  sunOpenMM = ''
  sunOpenMead = 'am'
  sunCloseHH = ''
  sunCloseMM = ''
  sunCloseMead = 'am'
  sunPrecheck

  offerMonday = false
  offerTuesday = false
  offerWednesday = false
  offerTurusday = false
  offerFriday = false
  offerSaturday = false
  offerSunday = false
  offerMonValue = ''
  offerTueValue = ''
  offerWedValue = ''
  offerThurValue = ''
  offerFriValue = ''
  offerSatValue = ''
  offerSunValue = ''


  menuLinkCondition = false
  urlLink = ''

  src: string = "../../../assets/images/Ellipse 11.png";
  featureSrc: string = 'null'
  restopop: number = 0
  searchText: string
  restoName = ''
  restoEmail = ''
  restoPhone = ''
  restoAddress = ''
  restoDescrip
  restoStreetName
  restoCity
  restoAvgRating
  restoLotitude
  restoLogitude
  restoServiceCharge
  spiceTol
  noOfTable
  offerValue
  restoMapLink
  menuSrc: any[] = []
  noResto: number
  foodbudMenu
  restoTrusted
  menuPdfCondition
  menuImgCondition
  pdfMenuSrc = 'null'
  sendData: any = new FormData()
  currentRestoId: any = null
  foodMenuAvalaible
  trusted
  reviewCount
  pdfRedirctVar
  logoToBeAppend: any = null
  featureImgToBeAppend: any = null
  menuImgToBeAppend: any[] = []
  menuPdfToBeAppend: any = null
  restoDetailsCondition = true
  queAns
  queAnsOtherText = ''

  delverooCon = false
  justEatCon = false
  uberEatsCon = false
  foodstuffCon = false
  delverooVal
  justEatVal
  uberEatsVal
  foodstuffVal
  instagramCon = false
  facebookCon = false
  googleMapCon = false
  instagramVal
  facebookVal
  googleMapVal
  otherDescriptionOrTags = ''

  restoLat
  restoLong
  onImageChange(event, id) {
    const fsize = event.target.files[0].size;
    const fileSize = (fsize / 1024);
    if (fileSize > 500) {
      this.toster.info(`Image can't be uploaded, as the size is bigger than 500 kb`, '', {
        timeOut: 11000,
      })
      document.getElementById(id)['value'] = ''
      return
    }
    this.logoToBeAppend = event.target.files[0]
    let file: File = event.target.files[0];
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (e: any) => {
      this.src = e.target.result;
      document.getElementById(id)['value'] = ''
    };
  }
  addResto() {

  }
  website
  updateRestoFunc(data) {
    this.httpSv.getOneD2RestoDetails(data).subscribe(res => {
      if (res['status'] == 'TRUE') {
        let temp = res['result'].data
        this.uniqueId = temp.restaurant_unique_id
        // dp
        if (typeof (temp.dietary_preferences) != 'string') {
          this.selectedDieatry = temp.dietary_preferences.map(element => {
            return element.diet_preference_id
          });
        }
        // allegens
        if (typeof (temp.allergens) != 'string') {
          this.selectedAllegens = temp.allergens.map(element => {
            return element.allergens_id
          });
        }
        //Category
        if (typeof (temp.categories) != 'string') {
          this.selectedCaategory = temp.categories.map(element => {
            return element.category_id
          });
        }
        // Cuisine
        if (typeof (temp.cuisines) != 'string') {
          this.selectedCuisine = temp.cuisines.map(element => {
            return element.cuisine_id
          });
        }

        this.restoName = temp.restaurant_name
        this.restoAddress = temp.restaurant_address
        this.restoDescrip = temp.description
        this.restoPhone = temp.contact_no
        this.restoLogitude = temp.longitude
        this.restoLotitude = temp.latitude
        this.restoMapLink = temp.google_map_url
        this.offerValue = temp.special_offer
        if (temp.logo) {
          this.src = temp.logo
        }
        this.restoStreetName = temp.street
        this.restoCity = temp.city
        this.restoAvgRating = temp.average_rating
        if (temp.foodbud_menu_available == 'Yes') {
          this.foodMenuAvalaible = 'Yes'
          this.foodbudMenu = true
        }
        else {
          this.foodMenuAvalaible = 'No'
          this.foodbudMenu = false
        }
        if (temp.trusted == 'Yes') {
          this.trusted = 'Yes'
          this.restoTrusted = true
        }
        else {
          this.trusted = 'No'
          this.restoTrusted = false
        }
        if (temp.featured_image) this.featureSrc = temp.featured_image
        if (temp.menu_name_link) {
          let menuNameLink = temp.menu_name_link
          // if (temp.menu_name_link.length > 1) menuNameLink = temp.menu_name_link[0].split(',')
          // else menuNameLink = temp.menu_name_link[0]
          console.log(menuNameLink[0].includes('.jpg'))
          if (menuNameLink[0].includes('.pdf') || menuNameLink.length > 1 || menuNameLink[0].includes('.png') || menuNameLink[0].includes('.jpg') || menuNameLink[0].includes('.jpeg') || menuNameLink[0].includes('.svg')) {
            console.log('menuNameLink[0].includes()')
            if (temp.menu_name) {
              if (temp.menu_name[0].includes('.pdf')) {
                this.menuPdfCondition = true
                this.pdfRedirctVar = temp.menu_name[0]
                let splitArr = temp.menu_name[0].split('/')
                this.pdfMenuSrc = splitArr[splitArr.length - 1]
                this.pdfConditionMenu = true
              }
              else if ((temp.menu_name.length > 1 || temp.menu_name[0].includes('.png') || temp.menu_name[0].includes('.jpg') || temp.menu_name[0].includes('.jpeg') || temp.menu_name[0].includes('.svg'))) {
                this.menuImgCondition = true
                temp.menu_name.forEach(element => {
                  this.menuSrc.push({ src: element })
                });
                this.imgConditionMenu = true
              }
            }
            if (temp.menu_name_link) {
              let menuNameLink = temp.menu_name_link
              if (menuNameLink[0].includes('.pdf')) {
                this.menuPdfCondition = true
                this.pdfRedirctVar = temp.menu_name[0]
                let splitArr = temp.menu_name[0].split('/')
                this.pdfMenuSrc = splitArr[splitArr.length - 1]
                this.pdfConditionMenu = true
              }
              else if ((menuNameLink.length > 1 || menuNameLink[0].includes('.png') || menuNameLink[0].includes('.jpg') || menuNameLink[0].includes('.jpeg') || menuNameLink[0].includes('.svg')) && typeof (menuNameLink) != 'string') {
                // console.log('works 2')
                this.menuImgCondition = true
                menuNameLink.forEach(element => {
                  this.menuSrc.push({ src: element })
                });
                this.imgConditionMenu = true
              }
            }
          }
          else {
            this.menuLinkCondition = true
            this.urlLink = menuNameLink
          }
        }
        else {
          if (temp.menu_name) {
            if (temp.menu_name[0].includes('.pdf')) {
              this.menuPdfCondition = true
              this.pdfRedirctVar = temp.menu_name[0]
              let splitArr = temp.menu_name[0].split('/')
              this.pdfMenuSrc = splitArr[splitArr.length - 1]
              this.pdfConditionMenu = true
            }
            else if ((temp.menu_name.length > 1 || temp.menu_name[0].includes('.png') || temp.menu_name[0].includes('.jpg') || temp.menu_name[0].includes('.jpeg') || temp.menu_name[0].includes('.svg')) && typeof (temp.menu_name) != 'string') {
              this.menuImgCondition = true
              temp.menu_name.forEach(element => {
                this.menuSrc.push({ src: element })
              });
              this.imgConditionMenu = true
            }
          }
        }
        // if (temp.menu_name[0].includes('.pdf')) {
        //   this.menuPdfCondition = true
        //   this.pdfRedirctVar = temp.menu_name[0]
        //   let splitArr = temp.menu_name[0].split('/')
        //   this.pdfMenuSrc = splitArr[splitArr.length - 1]
        //   this.pdfConditionMenu = true
        // }
        // else if ((temp.menu_name.length > 1 || temp.menu_name[0].includes('.png') || temp.menu_name[0].includes('.jpg') || temp.menu_name[0].includes('.jpeg') || temp.menu_name[0].includes('.svg')) && typeof (temp.menu_name) != 'string') {
        //   this.menuImgCondition = true
        //   temp.menu_name.forEach(element => {
        //     this.menuSrc.push({ src: element })
        //   });
        //   this.imgConditionMenu = true
        // }

        if (temp.opening_hours) {
          let time = temp.opening_hours.split(',')
          time.forEach(element => {
            element = element.replaceAll(/\s/g, '')
            let temp1
            let dayTime
            let openHH
            let openMM
            let openMead = 'am'
            let closeHH
            let closeMM
            let closeMead = 'am'
            let flag
            let [day, ...time] = element.split(':')
            dayTime = time.join(':')
            dayTime = dayTime.replace('[', '')
            dayTime = dayTime.replace(']', '')
            temp1 = dayTime.split('-')
            if (temp1[0] != 'Closed') {

              if (temp1[0].includes(':')) {
                let temp = temp1[0].split(':')
                openHH = temp[0]
                if (temp[1].length > 2) {
                  let num = temp[1].match(/\d+/g);
                  let letr = temp[1].match(/[a-zA-Z]+/g);
                  openMM = num[0]
                  openMead = letr[0]
                  flag = true
                }
                else {
                  openMM = temp1[1]
                  flag = false
                }
              }
              else {
                openMM = '00'
                if (temp1[0].length > 2) {
                  let num = temp1[0].match(/\d+/g);
                  let letr = temp1[0].match(/[a-zA-Z]+/g);
                  openHH = num[0]
                  openMead = letr[0]
                  flag = true
                }
                else {
                  openHH = temp1[0]
                  flag = false
                }
              }

              if (temp1[1].includes(':')) {
                let temp = temp1[1].split(':')
                closeHH = temp[0]
                let num = temp[1].match(/\d+/g);
                let letr = temp[1].match(/[a-zA-Z]+/g);
                closeMM = num[0]
                closeMead = letr[0]

                if (!flag) {
                  openMead = closeMead
                }

              }
              else {
                closeMM = '00'
                let num = temp1[1].match(/\d+/g);
                let letr = temp1[1].match(/[a-zA-Z]+/g);
                closeHH = num[0]
                closeMead = letr[0]

                if (!flag) {
                  openMead = closeMead
                }

              }
              day = day.trim()
              if (day == 'Monday') {
                if (dayTime != 'null') {

                  this.monOpenHH = openHH
                  this.monOpenMM = openMM
                  this.monOpenMead = openMead
                  this.monCloseHH = closeHH
                  this.monCloseMM = closeMM
                  this.monCloseMead = closeMead
                  this.monPrecheck = true
                  this.monClearCondition = true
                }
              }
              else if (day == 'Tuesday') {
                if (temp1[1] != 'null') {
                  this.tueOpenHH = openHH
                  this.tueOpenMM = openMM
                  this.tueOpenMead = openMead
                  this.tueCloseHH = closeHH
                  this.tueCloseMM = closeMM
                  this.tueCloseMead = closeMead
                  this.tuePrecheck = true
                  this.tueClearCondition = true
                }
              }
              else if (day == 'Wednesday') {
                if (temp1[1] != 'null') {
                  this.wedOpenHH = openHH
                  this.wedOpenMM = openMM
                  this.wedOpenMead = openMead
                  this.wedCloseHH = closeHH
                  this.wedCloseMM = closeMM
                  this.wedCloseMead = closeMead
                  this.wedPrecheck = true
                  this.wedClearCondition = true
                }
              }
              else if (day == 'Thursday') {
                if (temp1[1] != 'null') {
                  this.thurOpenHH = openHH
                  this.thurOpenMM = openMM
                  this.thurOpenMead = openMead
                  this.thurCloseHH = closeHH
                  this.thurCloseMM = closeMM
                  this.thurCloseMead = closeMead
                  this.thurPrecheck = true
                  this.thurClearCondition = true

                }
              }
              else if (day == 'Friday') {
                if (temp1[1] != 'null') {
                  this.friOpenHH = openHH
                  this.friOpenMM = openMM
                  this.friOpenMead = openMead
                  this.friCloseHH = closeHH
                  this.friCloseMM = closeMM
                  this.friCloseMead = closeMead
                  this.friPrecheck = true
                  this.friClearCondition = true
                }
              }
              else if (day == 'Saturday') {
                if (temp1[1] != 'null') {
                  this.satOpenHH = openHH
                  this.satOpenMM = openMM
                  this.satOpenMead = openMead
                  this.satCloseHH = closeHH
                  this.satCloseMM = closeMM
                  this.satCloseMead = closeMead
                  this.satPrecheck = true
                  this.satClearCondition = true
                }
              }
              else {
                if (temp1[1] != 'null') {
                  this.sunOpenHH = openHH
                  this.sunOpenMM = openMM
                  this.sunOpenMead = openMead
                  this.sunCloseHH = closeHH
                  this.sunCloseMM = closeMM
                  this.sunCloseMead = closeMead
                  this.sunPrecheck = true
                  this.sunClearCondition = true
                }
              }
            }
          });
        }
        if (temp.special_offer) {
          let splitArray = temp.special_offer.split(',')
          splitArray.forEach(element => {
            let day = element.split(':')
            if (day[0] == 'Monday') {
              if (day[1] != 'null') {
                this.offerMonday = true
                this.offerMonValue = day[1]
              }
            }
            else if (day[0] == 'Tuesday') {
              if (day[1] != 'null') {
                this.offerTuesday = true
                this.offerTueValue = day[1]
              }
            }
            else if (day[0] == 'Wednesday') {
              if (day[1] != 'null') {
                this.offerWednesday = true
                this.offerWedValue = day[1]
              }
            }
            else if (day[0] == 'Thursday') {
              if (day[1] != 'null') {
                this.offerTurusday = true
                this.offerThurValue = day[1]
              }
            }
            else if (day[0] == 'Friday') {
              if (day[1] != 'null') {
                this.offerFriday = true
                this.offerFriValue = day[1]
              }
            }
            else if (day[0] == 'Saturday') {
              if (day[1] != 'null') {
                this.offerSaturday = true
                this.offerSatValue = day[1]
              }
            }
            else {
              if (day[1] != 'null') {
                this.offerSunday = true
                this.offerSunValue = day[1]
              }
            }
          });
        }
        if (temp.instagram_link && temp.instagram_link != 'NA' && temp.instagram_link != 'null') {
          this.instagramCon = true
          this.instagramVal = temp.instagram_link
        }
        if (temp.social_link) {
          this.facebookCon = true
          this.facebookVal = temp.social_link
        }
        if (temp.google_map_url && temp.google_map_url != 'null') {
          this.googleMapCon = true
          this.googleMapVal = temp.google_map_url
        }
        if (temp.delivery_partner) {
          let deliverArr = temp.delivery_partner.split(',')
          deliverArr.forEach(element => {
            let [partnerName, ...temp1] = element.split(':')
            temp1 = temp1.join(':')
            if (partnerName == 'Deliveroo') {
              if (temp1 != 'null') {
                this.delverooCon = true
                this.delverooVal = temp1
              }
            }
            else if (partnerName == 'JustEat') {
              if (temp1 != 'null') {
                this.justEatCon = true
                this.justEatVal = temp1
              }
            }
            else if (partnerName == 'UberEats') {
              if (temp1 != 'null') {
                this.uberEatsCon = true
                this.uberEatsVal = temp1
              }
            }
            else if (partnerName == 'Foodstuff') {
              if (temp1 != 'null') {
                this.foodstuffCon = true
                this.foodstuffVal = temp1
              }
            }
          });
        }
        if (temp.appropriate_food_allergy_message) {
          if (temp.appropriate_food_allergy_message == 'A' || temp.appropriate_food_allergy_message == 'B' || temp.appropriate_food_allergy_message == 'C')
            this.queAns = temp.appropriate_food_allergy_message
          else {
            this.queAns = 'D'
            this.queAnsOtherText = temp.appropriate_food_allergy_message
          }
        }
        if (temp.description_and_tags) {
          this.otherDescriptionOrTags = temp.description_and_tags
        }
        this.restoLat = temp.restaurant_lat
        this.restoLong = temp.restaurant_long
        this.reviewCount = temp.review_count
        this.website = temp.website
      }
    })
  }
  openDialog(data) {

  }
  activateRestoFunc(data) {

  }
  closeResto() { }
  submitRestoCreate() { }

  // for dietary prefrance
  onMaterialGroupChange(event) {

  }


  getAllergens() {
    this.httpSv.getAllD2DAllergen().subscribe(res => {
      if (res['status'] == 'TRUE') {
        this.allAllergens = res['result'].data
        this.cIsEditDisabled = true
      }
    })
  }

  getDietPref() {
    this.httpSv.getAllD2Dieatry().subscribe(res => {
      if (res['status'] === 'TRUE') {
        this.allDieatary = res['result'].data;
        // let tempAllDietary = [...this.allDieatary]
        console.log(this.allDieatary)
        // console.log(tempAllDietary)
        const normalize = (str: string): string =>
          str?.trim().replace(/\s+/g, '').replace(/options?$/i, '').toLowerCase();

        if (this.openAiRestoInfo?.['Dietary Preference']) {
          let aiPrefs = this.openAiRestoInfo['Dietary Preference'];
          this.openAiRestoInfo['Dietary Preference'] = []
          if (!Array.isArray(aiPrefs)) aiPrefs = [aiPrefs];

          aiPrefs.forEach(pref => {
            const normalizedPref = normalize(pref);
            let bestScore = 0;
            let bestMatchId = null;

            this.allDieatary.forEach(diet => {
              const normalizedDiet = normalize(diet.name);
              const score = this.fuzzyMatch.similarity(normalizedPref, normalizedDiet);
              if (score > bestScore && score > 0.7) {
                bestScore = score;
                bestMatchId = diet.id;
              }
            });

            // this.allDieatary = [...tempAllDietary]
            if (bestMatchId && !this.selectedDieatry.includes(bestMatchId)) {
              this.selectedDieatry.push(bestMatchId);
              const matchedDiet = this.allDieatary.find(diet => diet.id == bestMatchId);
              console.log(this.openAiRestoInfo['Dietary Preference'])

              if (matchedDiet) {
                this.openAiRestoInfo['Dietary Preference'].push(matchedDiet.name);
              }
            }
          });
          console.log(this.openAiRestoInfo['Dietary Preference'])
        }

        if (!this.openAiRestoInfo) {
          this.loader = false;
        }
      }
    });
  }

  getCategory() {
    this.httpSv.allCategory().subscribe(res => {
      if (res['status'] === 'TRUE') {
        this.allCaategory = [];
        const temp = res['result'].data;

        temp.forEach(element => {
          this.allCaategory = [...this.allCaategory, ...element.category];
        });


        console.log(this.allCaategory)
        const normalize = (str: string): string =>
          str?.toLowerCase().replace(/\s+/g, '').replace(/food|foods/g, '').replace(/s$/, '').trim();

        const synonyms: { [key: string]: string } = {
          'pubfood': 'pub',
          'softdrinks': 'beverages',
          'starters': 'starter',
          'mains': 'main',
          'alcoholicbeverages': 'alcohol',
          'hotdrinks': 'beverages',
          'snacks': 'snack'
        };

        const aiCategories = this.openAiRestoInfo?.['Food Categories'];
        this.openAiRestoInfo['Food Categories'] = []
        if (aiCategories) {
          let aiList = Array.isArray(aiCategories) ? aiCategories : [aiCategories];

          aiList.forEach(aiCat => {
            let normalizedCat = normalize(aiCat);

            // Check synonyms first
            if (synonyms[normalizedCat]) {
              normalizedCat = synonyms[normalizedCat];
            }

            let bestScore = 0;
            let bestMatchId = null;

            this.allCaategory.forEach(cat => {
              const normalizedDbCat = normalize(cat.category_name);
              const score = this.fuzzyMatch.similarity(normalizedCat, normalizedDbCat);

              if (score > bestScore && score > 0.7) {
                bestScore = score;
                bestMatchId = cat.category_id;
              }
            });

            if (bestMatchId && !this.selectedCaategory.includes(bestMatchId)) {
              this.selectedCaategory.push(bestMatchId);
              this.openAiRestoInfo['Food Categories'].push(this.allCaategory.find(cat => cat.category_id == bestMatchId).category_name);
            }
          });
        }
        console.log(this.allCaategory)
      }
    });
  }

  getCuisine() {
    this.httpSv.getAllD2Cuisine().subscribe(res => {
      if (res['status'] === 'TRUE') {
        this.allCuisine = res['result'].data;

        const normalize = (str: string): string =>
          str?.toLowerCase().trim().replace(/\s+/g, '');

        const aiCuisine = this.openAiRestoInfo?.['Cuisine'];
        this.openAiRestoInfo['Cuisine'] = []
        if (aiCuisine) {
          let cuisineList = Array.isArray(aiCuisine) ? aiCuisine : [aiCuisine];

          cuisineList.forEach(aiCui => {
            const normalizedCuisine = normalize(aiCui);
            let bestScore = 0;
            let bestMatchId = null;

            this.allCuisine.forEach(cui => {
              const normalizedDbCui = normalize(cui.name);
              const score = this.fuzzyMatch.similarity(normalizedCuisine, normalizedDbCui);
              if (score > bestScore && score > 0.7) {
                bestScore = score;
                bestMatchId = cui.id;
              }
            });

            if (bestMatchId && !this.selectedCuisine.includes(bestMatchId)) {
              this.selectedCuisine.push(bestMatchId);
              this.openAiRestoInfo['Cuisine'].push(this.allCuisine.find(cui => cui.id === bestMatchId).name);
            }
          });
        }
      }
    });
  }

  spacialOffer: any = {
    "Monday": { 'flag': false, 'value': null },
    "Tuesday": { 'flag': false, 'value': null },
    "Wednesday": { 'flag': false, 'value': null },
    "Thursday": { 'flag': false, 'value': null },
    "Friday": { 'flag': false, 'value': null },
    "Saturday": { 'flag': false, 'value': null },
    "Sunday": { 'flag': false, 'value': null }
  }
  weekdaySort = (a: any, b: any): number => {
    const order = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
    return order.indexOf(a.key) - order.indexOf(b.key);
  };


  selectAllForDropdownItems(items: any[]) {
    let allSelect = (items) => {
      items.forEach((element) => {
        element['selectedAllGroup'] = 'selectedAllGroup';
      });
    };

    allSelect(items);
  }
  onFeatureImgChange(event, id) {
    const fsize = event.target.files[0].size;
    const fileSize = (fsize / 1024);
    if (fileSize > 500) {
      this.toster.info(`Image can't be uploaded, as the size is bigger than 500 kb`, '', {
        timeOut: 11000,
      })
      document.getElementById(id)['value'] = ''
      return
    }
    this.featureImgToBeAppend = event.target.files[0]
    let file: File = event.target.files[0];
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (e: any) => {
      this.featureSrc = e.target.result;
      document.getElementById(id)['value'] = ''
    };
  }
  imgUploadChechFunc(data) {
    if (this.pdfMenuSrc == 'null') {
      data.click()
    }
    else {
      let con = confirm('Are you sure to upload the image , this will delete the pdf file')
      if (con) {
        this.pdfMenuSrc = 'null'
        this.menuPdfToBeAppend = null
        data.click()
      }
    }
  }
  onMenuChange(event, id) {
    const fsize = event.target.files[0].size;
    const fileSize = (fsize / 1024);
    if (fileSize > 500) {
      this.toster.info(`Image can't be uploaded, as the size is bigger than 500 kb`, '', {
        timeOut: 11000,
      })
      document.getElementById(id)['value'] = ''
      return
    }
    this.menuLinkCondition = false
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (e: any) => {
      let temp = event.target.files[0].name.split('.')
      if (temp[temp.length - 1] != 'pdf') {
        this.menuImgToBeAppend.push(event.target.files[0])
        this.menuPdfToBeAppend = null
        this.menuSrc.push({ src: e.target.result, name: event.target.files[0].name })
        document.getElementById(id)['value'] = ''
      }
      else {
        this.pdfUploadCheckFunc(event, id)
      }
    }
  }
  pdfUploadCheckFunc(data, id) {
    if (this.menuSrc.length != 0) {
      let con = confirm('Are you sure to upload the pdf , this will delete the images')
      if (con) {
        this.menuSrc = []
        this.menuImgToBeAppend = []
        this.onMenuPdfChange(data, id)

      }
      else {
        document.getElementById(id)['value'] = ''
      }

    }
    else {
      this.onMenuPdfChange(data, id)
    }
  }

  onMenuPdfChange(event, id) {
    this.menuPdfToBeAppend = event.target.files[0]
    this.pdfMenuSrc = event.target.files[0].name
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (e: any) => {
      this.pdfRedirctVar = e.target.result
      document.getElementById(id)['value'] = ''
      this.menuSrc = []
      this.menuImgToBeAppend = []
    };

  }
  pdfConditionMenu: boolean = false
  imgConditionMenu: boolean = false
  pdfOrImagefunc(data) {
    if (data == 'pdf') {
      this.pdfConditionMenu = true
      this.imgConditionMenu = false
    }
    else {
      this.imgConditionMenu = true
      this.pdfConditionMenu = false
    }
  }

  openpdf() {
    window.open(this.pdfRedirctVar)
  }
  openImgFunc(src) {
    window.open(src.toString())
  }
  foodBudMenuFunc(data) {
    if (data) {
      this.foodMenuAvalaible = 'Yes'
    } else {
      this.foodMenuAvalaible = 'No'
    }
  }
  trustedFunc(data) {
    if (data) {
      this.trusted = 'Yes'
    } else {
      this.trusted = 'No'
    }
  }
  deleteImg(data) {
    let indexMenuSrc = this.menuSrc.findIndex(ele => {
      return ele.name == data.name
    })
    this.menuSrc.splice(indexMenuSrc, 1)
    if (data.src.includes('base64')) {
      let indexMenuAppend = this.menuImgToBeAppend.findIndex(ele => {
        return ele.name == data.name
      })
      this.menuImgToBeAppend.splice(indexMenuAppend, 1)
    }
  }
  pdfDelete() {
    if (this.menuImgToBeAppend) {
      this.pdfMenuSrc = 'null'
      this.menuPdfToBeAppend = null
    }
  }
  deselect(id) {
    if (id == 'cuisine') {
      this.selectedCuisine = []
    }
    else if (id == 'categories') this.selectedCaategory = []
    else if (id == 'dietPref') this.selectedDieatry = []
    else if (id == 'allergien') this.selectedAllegens = []
    let temp = document.getElementById(id).children
    for (let i = 0; i < temp.length; i++) {
      if (temp[i].children[0]['checked']) {
        temp[i].children[0]['checked'] = false
      }

    }
  }
  timeClear(id) {
    if (id == 'mondayTime') {
      this.monOpenHH = ''
      this.monOpenMM = ''
      this.monOpenMead = 'am'
      this.monCloseHH = ''
      this.monCloseMM = ''
      this.monCloseMead = 'am'
    }
    else if (id == 'tuesdayTime') {
      this.tueOpenHH = ''
      this.tueOpenMM = ''
      this.tueOpenMead = 'am'
      this.tueCloseHH = ''
      this.tueCloseMM = ''
      this.tueCloseMead = 'am'
    }
    else if (id == 'wednesTime') {
      this.wedOpenHH = ''
      this.wedOpenMM = ''
      this.wedOpenMead = 'am'
      this.wedCloseHH = ''
      this.wedCloseMM = ''
      this.wedCloseMead = 'am'
    }
    else if (id == 'thursdayTime') {
      this.thurOpenHH = ''
      this.thurOpenMM = ''
      this.thurOpenMead = 'am'
      this.thurCloseHH = ''
      this.thurCloseMM = ''
      this.thurCloseMead = 'am'
    }
    else if (id == "fridayTime") {
      this.friOpenHH = ''
      this.friOpenMM = ''
      this.friOpenMead = 'am'
      this.friCloseHH = ''
      this.friCloseMM = ''
      this.friCloseMead = 'am'
    }
    else if (id == 'saturdayTime') {
      this.satOpenHH = ''
      this.satOpenMM = ''
      this.satOpenMead = 'am'
      this.satCloseHH = ''
      this.satCloseMM = ''
      this.satCloseMead = 'am'
    }
    else if (id == 'sundayTime') {
      this.sunOpenHH = ''
      this.sunOpenMM = ''
      this.sunOpenMead = 'am'
      this.sunCloseHH = ''
      this.sunCloseMM = ''
      this.sunCloseMead = 'am'
    }
  }
  timeSmallClear(id) {
    let temp1 = document.getElementById(id + 'OpenSmall').children
    let temp2 = document.getElementById(id + 'CloseSmall').children

    for (let i = 0; i < temp1.length; i++) {
      if (temp1[i]['type'] == 'number') {
        temp1[i]['value'] = ''
      }
      else if (temp1[i]['type'] == 'select-one') {
        temp1[i]['value'] = 'am'
      }
    }
    for (let i = 0; i < temp2.length; i++) {
      if (temp2[i]['type'] == 'number') {
        temp2[i]['value'] = ''
      }
      else if (temp2[i]['type'] == 'select-one') {
        temp2[i]['value'] = 'am'
      }
    }
  }
  timeInputFuncTest(val) {
    let [day, staus] = val.split(':')

  }
  timeInputFunc(val) {
    let [day, staus] = val.split(':')
    if (staus == 'true') {
      if (day == 'mondayTime') {
        this.monClearCondition = true
      }
      else if (day == 'tuesdayTime') {
        this.tueClearCondition = true
      }
      else if (day == 'wednesTime') {
        this.wedClearCondition = true
      }
      else if (day == 'thursdayTime') {
        this.thurClearCondition = true
      }
      else if (day == 'fridayTime') {
        this.friClearCondition = true
      }
      else if (day == 'saturdayTime') {
        this.satClearCondition = true
      }
      else if (day == 'sundayTime') {
        this.sunClearCondition = true
      }
    }
    else {
      if (day == 'mondayTime') {
        this.timeClear(day)
        this.monClearCondition = false
      }
      else if (day == 'tuesdayTime') {
        this.timeClear(day)
        this.tueClearCondition = false
      }
      else if (day == 'wednesTime') {
        this.timeClear(day)
        this.wedClearCondition = false
      }
      else if (day == 'thursdayTime') {
        this.timeClear(day)
        this.thurClearCondition = false
      }
      else if (day == 'fridayTime') {
        this.timeClear(day)
        this.friClearCondition = false
      }
      else if (day == 'saturdayTime') {
        this.timeClear(day)
        this.satClearCondition = false
      }
      else if (day == 'sundayTime') {
        this.timeClear(day)
        this.sunClearCondition = false
      }
    }
  }
  offerHandelFunc(day, e) {
    if (e.checked) {
      if (day == 'mon') {
        this.offerMonday = true
      }
      else if (day == 'tue') {
        this.offerTuesday = true
      }
      else if (day == 'wed') {
        this.offerWednesday = true
      }
      else if (day == 'thu') {
        this.offerTurusday = true
      }
      else if (day == 'fri') {
        this.offerFriday = true
      }
      else if (day == 'sat') {
        this.offerSaturday = true
      }
      else if (day == 'sun') {
        this.offerSunday = true
      }
    }
    else {
      if (day == 'mon') {
        this.offerMonday = false
      }
      else if (day == 'tue') {
        this.offerTuesday = false
      }
      else if (day == 'wed') {
        this.offerWednesday = false
      }
      else if (day == 'thu') {
        this.offerTurusday = false
      }
      else if (day == 'fri') {
        this.offerFriday = false
      }
      else if (day == 'sat') {
        this.offerSaturday = false
      }
      else if (day == 'sun') {
        this.offerSunday = false
      }

    }
  }
  preRadioSelect(option) {
    if (option == this.queAns) return true
    else false
  }
  deselectOffer() {
    this.offerMonday = false
    this.offerTuesday = false
    this.offerWednesday = false
    this.offerTurusday = false
    this.offerFriday = false
    this.offerSaturday = false
    this.offerSunday = false
    this.offerMonValue = ''
    this.offerTueValue = ''
    this.offerWedValue = ''
    this.offerThurValue = ''
    this.offerFriValue = ''
    this.offerSatValue = ''
    this.offerSunValue = ''
  }
  deleteFeatureImgFunc() {
    this.featureSrc = 'null'
  }
  menuLinkInsert() {
    this.menuLinkCondition = true
  }
  menuImgDelete(index) {
    this.menuSrc.splice(index, 1)
  }

  preSelectFunc(type: string, id) {
    if (type == 'cuisines') {
      return this.selectedCuisine.includes(id)
    }
    else if (type == 'categories') {
      return this.selectedCaategory.includes(id)
    }
    else if (type == 'dietPref') {
      return this.selectedDieatry.includes(id)
    }
    else if (type == 'allergies') {
      return this.selectedAllegens.includes(id)
    }
  }
  copyTimeFunc(day) {
    if (day == 'tue') {
      this.tueOpenHH = this.monOpenHH
      this.tueOpenMM = this.monOpenMM
      this.tueOpenMead = this.monOpenMead
      this.tueCloseHH = this.monCloseHH
      this.tueCloseMM = this.monCloseMM
      this.tueCloseMead = this.monCloseMead

    }
    else if (day == 'wed') {
      this.wedOpenHH = this.tueOpenHH
      this.wedOpenMM = this.tueOpenMM
      this.wedOpenMead = this.tueOpenMead
      this.wedCloseHH = this.tueCloseHH
      this.wedCloseMM = this.tueCloseMM
      this.wedCloseMead = this.tueCloseMead
    }
    else if (day == 'thur') {
      this.thurOpenHH = this.wedOpenHH
      this.thurOpenMM = this.wedOpenMM
      this.thurOpenMead = this.wedOpenMead
      this.thurCloseHH = this.wedCloseHH
      this.thurCloseMM = this.wedCloseMM
      this.thurCloseMead = this.wedCloseMead
    }
    else if (day == 'fri') {
      this.friOpenHH = this.thurOpenHH
      this.friOpenMM = this.thurOpenMM
      this.friOpenMead = this.thurOpenMead
      this.friCloseHH = this.thurCloseHH
      this.friCloseMM = this.thurCloseMM
      this.friCloseMead = this.thurCloseMead
    }
    else if (day == 'sat') {
      this.satOpenHH = this.friOpenHH
      this.satOpenMM = this.friOpenMM
      this.satOpenMead = this.friOpenMead
      this.satCloseHH = this.friCloseHH
      this.satCloseMM = this.friCloseMM
      this.satCloseMead = this.friCloseMead
    }
    else if (day == 'sun') {
      this.sunOpenHH = this.satOpenHH
      this.sunOpenMM = this.satOpenMM
      this.sunOpenMead = this.satOpenMead
      this.sunCloseHH = this.satCloseHH
      this.sunCloseMM = this.satCloseMM
      this.sunCloseMead = this.satCloseMead
    }

  }
  allergensCheckedUncheckedFunc(e, id) {
    if (e.checked) {
      this.selectedAllegens.push(id)
    }
    else {
      let index = this.selectedAllegens.findIndex(ele => ele == id)
      this.selectedAllegens.splice(index, 1)

    }
  }
  cuisineCheckedUncheckedFunc(e, id) {
    if (e.checked) {
      this.selectedCuisine.push(id)
    }
    else {
      let index = this.selectedCuisine.findIndex(ele => ele == id)
      this.selectedCuisine.splice(index, 1)
    }
  }
  catCheckedUncheckedFunc(e, id) {
    if (e.checked) {
      this.selectedCaategory.push(id)
    }
    else {
      let index = this.selectedCaategory.findIndex(ele => ele == id)
      this.selectedCaategory.splice(index, 1)
    }

    console.log(this.selectedCaategory)
  }
  dpCheckedUncheckedFunc(e, id) {
    if (e.checked) {
      this.selectedDieatry.push(id)
    }
    else {
      let index = this.selectedDieatry.findIndex(ele => ele == id)
      this.selectedDieatry.splice(index, 1)
    }
  }
  timePreCheck(day) {
    if (day == 'mon') {
      if (this.monClearCondition) return true
      else return false
    }
    else if (day == 'tue') {
      if (this.tueClearCondition) return true
      else return false
    }
    else if (day == 'wed') {
      if (this.wedClearCondition) return true
      else return false
    }
    else if (day == 'thu') {
      if (this.thurClearCondition) return true
      else return false
    }
    else if (day == 'fri') {
      if (this.friClearCondition) return true
      else return false
    }
    else if (day == 'sat') {
      if (this.satClearCondition) return true
      else return false
    }
    else if (day == 'sun') {
      if (this.sunClearCondition) return true
      else return false
    }
  }

  partialId: any = null
  nextPageFunc() {
    if (document.getElementsByClassName('inputBoxErrorClass').length > 0) {
      document.getElementsByClassName('inputBoxErrorClass')[0].classList.remove('inputBoxErrorClass')
    }
    if (this.restoName.length > 0) {
      if (this.restoEmail.length > 0) {
        if (this.restoEmail.includes('@') && this.restoEmail.includes('.')) {
          if (this.restoPhone) {
            if (this.phoneNumberValidate()) {
              if (this.restoAddress.length > 0) {
                const payload = new FormData()
                payload.append('restaurant_name', this.restoName)
                payload.append('restaurant_address', this.restoAddress)
                payload.append('restaurant_telephone', this.restoPhone)
                payload.append('restaurant_email', this.restoEmail)
                if (this.logoToBeAppend) {
                  payload.append('logo', this.logoToBeAppend)
                }
                else if (this.src != '../../../assets/images/Ellipse 11.png') {
                  payload.append('logo', this.src)
                }
                if (this.featureImgToBeAppend) {
                  payload.append('featured_image', this.featureImgToBeAppend)
                }
                else if (this.featureSrc != 'null') {
                  payload.append('featured_image', this.featureSrc)
                }

                if (this.partialId) {
                  payload.append('resto_id', this.partialId)
                }
                this.httpSv.updateD2PartialResto(payload).subscribe((res: any) => {
                  if (res['status']) {
                    this.partialId = res['result'].data.claimed_restoId
                    this.restoDetailsCondition = false
                  } else {
                    this.toster.error('Oops! Something went wrong', '', { timeOut: 2000 })
                  }
                }, err => this.toster.error('Oops! Something went wrong', '', { timeOut: 2000 }))

              }
              else {
                setTimeout(() => {
                  document.getElementById('restoOfficalAddress').classList.add('inputBoxErrorClass')
                }, 0)
                this.toster.error('Please enter the address', '', {
                  timeOut: 3000,
                })
              }
            }
            else {
              setTimeout(() => {
                document.getElementById('restoOfficalPhone').classList.add('inputBoxErrorClass')
              }, 0)
              this.toster.error('Please enter valid phone number', '', {
                timeOut: 3000,
              })

            }
          }
          else {
            setTimeout(() => {
              document.getElementById('restoOfficalPhone').classList.add('inputBoxErrorClass')
            }, 0)
            this.toster.error('Please enter phone number', '', {
              timeOut: 3000,
            })
          }
        }
        else {
          setTimeout(() => {
            document.getElementById('restoOfficalEmail').classList.add('inputBoxErrorClass')
          }, 0)
          this.toster.error('Please enter valid email', '', {
            timeOut: 3000,
          })
        }
      }
      else {
        setTimeout(() => {
          document.getElementById('restoOfficalEmail').classList.add('inputBoxErrorClass')
        }, 0)
        this.toster.error('Please enter the email', '', {
          timeOut: 3000,
        })
      }

    } else {
      setTimeout(() => {
        document.getElementById('restoName').classList.add('inputBoxErrorClass')
      }, 0)
      this.toster.error('Please enter restaurant name', '', {
        timeOut: 3000,
      })
    }

  }
  openingClosingValidate() {
    if (this.monClearCondition) {
      if ((this.monOpenHH ? this.monOpenHH.toString().length > 0 : false) && (this.monOpenMM ? this.monOpenMM.toString().length > 0 : false) && (this.monCloseHH ? this.monCloseHH.toString().length > 0 : false) && (this.monCloseMM ? this.monCloseMM.toString().length > 0 : false)) {
      }
      else {
        return false
      }
    }
    if (this.tueClearCondition) {
      if ((this.tueOpenHH ? this.tueOpenHH.toString().length > 0 : false) && (this.tueOpenMM ? this.tueOpenMM.toString().length > 0 : false) && (this.tueCloseHH ? this.tueCloseHH.toString().length > 0 : false) && (this.tueCloseMM ? this.tueCloseMM.toString().length > 0 : false)) {
      }
      else {
        return false
      }
    }
    if (this.wedClearCondition) {
      if ((this.wedOpenHH ? this.wedOpenHH.toString().length > 0 : false) && (this.wedOpenMM ? this.wedOpenMM.toString().length > 0 : false) && (this.wedCloseHH ? this.wedCloseHH.toString().length > 0 : false) && (this.wedCloseMM ? this.wedCloseMM.toString().length > 0 : false)) {
      }
      else {
        return false
      }
    }
    if (this.thurClearCondition) {
      if ((this.thurOpenHH ? this.thurOpenHH.toString().length > 0 : false) && (this.thurOpenMM ? this.thurOpenMM.toString().length > 0 : false) && (this.thurCloseHH ? this.thurCloseHH.toString().length > 0 : false) && (this.thurCloseMM ? this.thurCloseMM.toString().length > 0 : false)) {
      }
      else {
        return false
      }
    }
    if (this.friClearCondition) {
      if ((this.friOpenHH ? this.friOpenHH.toString().length > 0 : false) && (this.friOpenMM ? this.friOpenMM.toString().length > 0 : false) && (this.friCloseHH ? this.friCloseHH.toString().length > 0 : false) && (this.friCloseMM ? this.friCloseMM.toString().length > 0 : false)) {
      }
      else {
        return false
      }
    }
    if (this.satClearCondition) {
      if ((this.satOpenHH ? this.satOpenHH.toString().length > 0 : false) && (this.satOpenMM ? this.satOpenMM.toString().length > 0 : false) && (this.satCloseHH ? this.satCloseHH.toString().length > 0 : false) && (this.satCloseMM ? this.satCloseMM.toString().length > 0 : false)) {
      }
      else {
        return false
      }
    }
    if (this.sunClearCondition) {
      if ((this.sunOpenHH ? this.sunOpenHH.toString().length > 0 : false) && (this.sunOpenMM ? this.sunOpenMM.toString().length > 0 : false) && (this.sunCloseHH ? this.sunCloseHH.toString().length > 0 : false) && (this.sunCloseMM ? this.sunCloseMM.toString().length > 0 : false)) {
      }
      else {
        return false
      }
    }
    return true
  }
  specialOfferValidate() {
    if (this.offerMonday) {
      if (this.offerMonValue ? this.offerMonValue.toString().length > 0 : false) { }
      else return false
    }
    if (this.offerTuesday) {
      if (this.offerTueValue ? this.offerTueValue.toString().length > 0 : false) { }
      else return false
    }
    if (this.offerWednesday) {
      if (this.offerWedValue ? this.offerWedValue.toString().length > 0 : false) { }
      else return false
    }
    if (this.offerTurusday) {
      if (this.offerThurValue ? this.offerThurValue.toString().length > 0 : false) { }
      else return false
    }
    if (this.offerFriday) {
      if (this.offerFriValue ? this.offerFriValue.toString().length > 0 : false) { }
      else return false
    }
    if (this.offerSaturday) {
      if (this.offerSatValue ? this.offerSatValue.toString().length > 0 : false) { }
      else return false
    }
    if (this.offerSunday) {
      if (this.offerSunValue ? this.offerSunValue.toString().length > 0 : false) { }
      else return false
    }
    return true
  }
  deleveryParterValidate() {
    if (this.delverooCon) {
      if (this.delverooVal ? this.delverooVal.length > 0 : false) { }
      else return false
    }
    if (this.justEatCon) {
      if (this.justEatVal ? this.justEatVal.length > 0 : false) { }
      else return false
    }
    if (this.uberEatsCon) {
      if (this.uberEatsVal ? this.uberEatsVal.length > 0 : false) { }
      else return false
    }
    if (this.foodstuffCon) {
      if (this.foodstuffVal ? this.foodstuffVal.length > 0 : false) { }
      else return false
    }
    return true
  }
  socialLinkValidate() {
    if (this.instagramCon) {
      if (this.instagramVal ? this.instagramVal.length > 0 : false) { }
      else return false
    }
    if (this.facebookCon) {
      if (this.facebookVal ? this.facebookVal.length > 0 : false) { }
      else return false
    }
    if (this.googleMapCon) {
      if (this.googleMapVal ? this.googleMapVal.length > 0 : false) { }
      else return false
    }
    return true
  }
  menuLinkValidate() {
    if (this.menuLinkCondition) {
      if (this.urlLink.length > 0) { }
      else return false
    }
    return true
  }
  phoneNumberValidate() {
    let temp = this.restoPhone.replace(' ', '')
    temp = this.restoPhone.replace('+', '')
    if (temp.length >= 9) return true
    else return false
  }
  submitClaimFunc() {
    if (document.getElementsByClassName('divConitainerErrorClass').length > 0) {
      document.getElementsByClassName('divConitainerErrorClass')[0].classList.remove('divConitainerErrorClass')
    }
    if (this.restoName.length > 0) {
      if (this.restoEmail.length > 0) {
        if (this.restoEmail.includes('@') && this.restoEmail.includes('.')) {
          if (this.restoPhone) {
            if (this.phoneNumberValidate()) {
              if (this.restoAddress.length > 0) {
                if (this.menuLinkValidate()) {
                  if (this.openingClosingValidate()) {
                    if (this.specialOfferValidate()) {
                      if (this.queAns) {
                        if (this.queAns != 'D' || (this.queAns == 'D' && this.queAnsOtherText.length > 1)) {
                          if (this.deleveryParterValidate()) {
                            if (this.socialLinkValidate()) {
                              if (!this.partialId) {
                                this.toster.info('Oops! Something breaks. Please try again later', '', { timeOut: 2000 })
                                return
                              }
                              this.sendData.append('restaurant_name', this.restoName)
                              this.sendData.append('restaurant_email', this.restoEmail)
                              this.sendData.append('restaurant_telephone', this.restoPhone)
                              this.sendData.append('restaurant_address', this.restoAddress)

                              if (this.logoToBeAppend) {
                                this.sendData.append('logo', this.logoToBeAppend)
                              }
                              else if (this.src != '../../../assets/images/Ellipse 11.png') {
                                this.sendData.append('logo', this.src)
                              }
                              if (this.featureImgToBeAppend) {
                                this.sendData.append('featured_image', this.featureImgToBeAppend)
                              }
                              else if (this.featureSrc != 'null') {
                                this.sendData.append('featured_image', this.featureSrc)
                              }
                              if (this.menuLinkCondition) {
                                this.sendData.append('menu_name_link[]', this.urlLink)
                              }
                              else {
                                if (this.pdfRedirctVar) {
                                  if (this.menuPdfToBeAppend) {
                                    this.sendData.append('menu_name[]', this.menuPdfToBeAppend)
                                  }
                                  else {
                                    this.sendData.append('menu_name_link[]', this.pdfMenuSrc)
                                  }
                                }
                                else if (this.menuSrc.length > 0) {
                                  let temp = []
                                  if (this.menuSrc.length == this.menuImgToBeAppend.length) {
                                    this.menuImgToBeAppend.forEach(ele => {
                                      this.sendData.append('menu_name[]', ele)
                                      // temp.push(ele)
                                    })
                                  }
                                  else {
                                    if (this.menuImgToBeAppend.length > 0) {
                                      this.menuImgToBeAppend.forEach(ele => {
                                        this.sendData.append('menu_name[]', ele)
                                      })
                                    }
                                    this.menuSrc.forEach(ele => {
                                      if (ele.src.includes('http')) temp.push(ele.src)
                                    })
                                    this.sendData.append('menu_name_link[]', temp)
                                  }
                                  // this.sendData.append('menu_name', JSON.stringify(temp))

                                }
                              }
                              this.sendData.append('allergens[]', this.selectedAllegens)
                              this.sendData.append('dietary_preferences[]', this.selectedDieatry)
                              this.sendData.append('cuisine[]', this.selectedCuisine)
                              this.sendData.append('category[]', this.selectedCaategory)
                              let mon = this.monClearCondition ? "Monday:" + this.monOpenHH + ":" + this.monOpenMM + ":" + this.monOpenMead + ':' + this.monCloseHH + ':' + this.monCloseMM + ':' + this.monCloseMead : "Monday:null"
                              let tue = this.tueClearCondition ? `Tuesday:${this.tueOpenHH}:${this.tueOpenMM}:${this.tueOpenMead}:${this.tueCloseHH}:${this.tueCloseMM}:${this.tueCloseMead}` : 'Tuesday:null'
                              let wed = this.wedClearCondition ? `Wednesday:${this.wedOpenHH}:${this.wedOpenMM}:${this.wedOpenMead}:${this.wedCloseHH}:${this.wedCloseMM}:${this.wedCloseMead}` : 'Wednesday:null'
                              let thur = this.thurClearCondition ? `Thursday:${this.thurOpenHH}:${this.thurOpenMM}:${this.thurOpenMead}:${this.thurCloseHH}:${this.thurCloseMM}:${this.thurCloseMead}` : 'Thursday:null'
                              let fri = this.friClearCondition ? `Friday:${this.friOpenHH}:${this.friOpenMM}:${this.friOpenMead}:${this.friCloseHH}:${this.friCloseMM}:${this.friCloseMead}` : 'Friday:null'
                              let sat = this.satClearCondition ? `Saturday:${this.satOpenHH}:${this.satOpenMM}:${this.satOpenMead}:${this.satCloseHH}:${this.satCloseMM}:${this.satCloseMead}` : 'Saturday:null'
                              let sun = this.sunClearCondition ? `Sunday:${this.sunOpenHH}:${this.sunOpenMM}:${this.sunOpenMead}:${this.sunCloseHH}:${this.sunCloseMM}:${this.sunCloseMead}` : 'Sunday:null'
                              let time = `${mon},${tue},${wed},${thur},${fri},${sat},${sun}`
                              this.sendData.append('opening_hours', time)
                              let monOffer = this.offerMonday ? "Monday:" + this.offerMonValue : "Monday:null"
                              let tueOffer = this.offerTuesday ? "Tuesday:" + this.offerTueValue : "Tuesday:null"
                              let wedOffer = this.offerWednesday ? "Wednesday:" + this.offerWedValue : "Wednesday:null"
                              let thurOffer = this.offerTurusday ? "Thursday:" + this.offerThurValue : "Thursday:null"
                              let friOffer = this.offerFriday ? "Friday:" + this.offerFriValue : "Friday:null"
                              let satOffer = this.offerSaturday ? "Saturday:" + this.offerSatValue : "Saturday:null"
                              let sunOffer = this.offerSunday ? "Sunday:" + this.offerSunValue : "Sunday:null"
                              let finalOffer = `${monOffer},${tueOffer},${wedOffer},${thurOffer},${friOffer},${satOffer},${sunOffer}`
                              this.sendData.append('special_offer', finalOffer)
                              if (this.queAns != 'D') this.sendData.append('appropriate_food_allergy_message', this.queAns)
                              else this.sendData.append('appropriate_food_allergy_message', this.queAnsOtherText)
                              // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
                              let deleviroo = this.delverooCon ? 'Deliveroo:' + this.delverooVal : 'Deliveroo:null'
                              let justeat = this.justEatCon ? 'JustEat:' + this.justEatVal : 'JustEat:null'
                              let ubereat = this.uberEatsCon ? 'UberEats:' + this.uberEatsVal : 'UberEats:null'
                              let foodstuf = this.foodstuffCon ? 'Foodstuff:' + this.foodstuffVal : 'Foodstuff:null'
                              let deleveryPartner = `${deleviroo},${justeat},${ubereat},${foodstuf}`
                              this.sendData.append('delivery_partner', deleveryPartner)

                              if (this.instagramCon) this.sendData.append('instagram_link', this.instagramVal)
                              else this.sendData.append('instagram_link', null)
                              if (this.facebookCon) this.sendData.append('social_link', this.facebookVal)
                              if (this.googleMapCon) this.sendData.append('google_map_url', this.googleMapVal)
                              else this.sendData.append('google_map_url', null)
                              if (this.otherDescriptionOrTags.length > 0) this.sendData.append('description_and_tags', this.otherDescriptionOrTags)

                              this.sendData.append('csv_restaurantId', currentSelectedRestoId)
                              this.sendData.append('description', this.restoDescrip)
                              this.sendData.append('trusted', this.trusted)
                              this.sendData.append('review_count', this.reviewCount)
                              this.sendData.append('average_rating', this.restoAvgRating)
                              this.sendData.append('website', this.website)
                              this.sendData.append('street', this.restoStreetName)
                              this.sendData.append('city', this.restoCity)
                              // this.sendData.append('old_restaurant_id', currentSelectedRestoId)

                              this.sendData.append('restaurant_poc_number', '11')
                              this.sendData.append('restaurant_poc_name', 'test')
                              this.sendData.append('restaurant_lat', this.restoLat)
                              this.sendData.append('restaurant_long', this.restoLong)
                              // console.log(time)
                              this.sendData.append('partial_id', this.partialId)

                              this.httpSv.claimSubmit(this.sendData).subscribe(res => {
                                if (res['status'] == 'TRUE') {
                                  this.last = true
                                }
                              })
                            }
                            else {
                              this.scroll.scrollToElementById('socialLink')
                              setTimeout(() => {
                                document.getElementById('socialLink').classList.add('divConitainerErrorClass')
                              }, 0)
                              this.toster.error('Please fill social links correctly', '', {
                                timeOut: 3000,
                              })
                            }
                          }

                          else {
                            this.scroll.scrollToElementById('deliveyPartner')
                            setTimeout(() => {
                              document.getElementById('deliveyPartner').classList.add('divConitainerErrorClass')
                            }, 0)
                            this.toster.error('Please fill delivary partner link correctly', '', {
                              timeOut: 3000,
                            })
                          }
                        }
                        else {

                          this.scroll.scrollToElementById('allergyMessage')
                          setTimeout(() => {
                            document.getElementById('allergyMessage').classList.add('divConitainerErrorClass')
                          }, 0)
                          this.toster.error('Please fill the allergy message', '', {
                            timeOut: 3000,
                          })
                        }

                      }

                      else {

                        this.scroll.scrollToElementById('allergyMessage')
                        setTimeout(() => {
                          document.getElementById('allergyMessage').classList.add('divConitainerErrorClass')
                        }, 0)
                        this.toster.error('Please choose allergy message', '', {
                          timeOut: 3000,
                        })
                      }
                    }
                    else {
                      this.scroll.scrollToElementById('specialOffer')
                      setTimeout(() => {
                        document.getElementById('specialOffer').classList.add('divConitainerErrorClass')
                      }, 0)
                      this.toster.error('Please fill special offer correctly', '', {
                        timeOut: 3000,
                      })
                    }
                  }
                  else {
                    this.scroll.scrollToElementById('openingClosingMainDiv')
                    setTimeout(() => {
                      document.getElementById('openingClosingMainDiv').classList.add('divConitainerErrorClass')
                    }, 0)
                    this.toster.error('Please fill opening and closing time correctly', '', {
                      timeOut: 3000,
                    })
                  }
                }
                else {
                  this.scroll.scrollToElementById('menuMainDiv')
                  setTimeout(() => {
                    document.getElementById('menuMainDiv').classList.add('divConitainerErrorClass')
                  }, 0)
                  this.toster.error('Please provide the menu url', '', {
                    timeOut: 3000,
                  })
                }
              }
              else {
                this.restoDetailsCondition = true
                setTimeout(() => {
                  document.getElementById('restoOfficalAddress').classList.add('inputBoxErrorClass')
                }, 0)
                this.toster.error('Please enter the address', '', {
                  timeOut: 3000,
                })
              }
            }
            else {

              this.restoDetailsCondition = true
              setTimeout(() => {
                document.getElementById('restoOfficalPhone').classList.add('inputBoxErrorClass')
              }, 0)
              this.toster.error('Please enter valid phone number', '', {
                timeOut: 3000,
              })

            }
          }
          else {
            this.restoDetailsCondition = true
            setTimeout(() => {
              document.getElementById('restoOfficalPhone').classList.add('inputBoxErrorClass')
            }, 0)
            this.toster.error('Please enter phone number', '', {
              timeOut: 3000,
            })
          }
        }
        else {
          this.restoDetailsCondition = true
          setTimeout(() => {
            document.getElementById('restoOfficalEmail').classList.add('inputBoxErrorClass')
          }, 0)
          this.toster.error('Please enter valid email', '', {
            timeOut: 3000,
          })
        }
      }
      else {

        this.restoDetailsCondition = true
        setTimeout(() => {
          document.getElementById('restoOfficalEmail').classList.add('inputBoxErrorClass')
        }, 0)
        this.toster.error('Please enter the email', '', {
          timeOut: 3000,
        })
      }

    } else {
      this.restoDetailsCondition = true
      setTimeout(() => {
        document.getElementById('restoName').classList.add('inputBoxErrorClass')
      }, 0)
      this.toster.error('Please enter restaurant name', '', {
        timeOut: 3000,
      })
    }
  }
  delevryHandelFunc(name, event) {
    if (event.checked) {
      if (name == 'deliveroo') this.delverooCon = true
      else if (name == 'justEat') this.justEatCon = true
      else if (name == 'uberEats') this.uberEatsCon = true
      else if (name == 'foodstuff') this.foodstuffCon = true
    }
    else {
      if (name == 'deliveroo') this.delverooCon = false
      else if (name == 'justEat') this.justEatCon = false
      else if (name == 'uberEats') this.uberEatsCon = false
      else if (name == 'foodstuff') this.foodstuffCon = false
    }
  }
  socialLinkHandelFunc(name, event) {
    if (event.checked) {
      if (name == 'insta') this.instagramCon = true
      else if (name == 'facebook') this.facebookCon = true
      else if (name == 'google-map') this.googleMapCon = true
    }
    else {
      if (name == 'insta') this.instagramCon = false
      else if (name == 'facebook') this.facebookCon = false
      else if (name == 'google-map') this.googleMapCon = false
    }
  }

  spacialOfferHandle(day, e) {
    if (e.checked) {
      this.spacialOffer[day].flag = true
    }
    else this.spacialOffer[day].flag = false
  }
  validate(event) {
    let k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k >= 48 && k <= 57));
  }
  validateNum(event) {
    let k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k >= 48 && k <= 57) || k == 43 || k == 32);
  }
}



@Component({
  selector: 'app-final-popup',
  templateUrl: './final-popup-screen.html',

})
export class FinalPopupComponent implements OnInit {
  imgurl: null | string
  isApproved: boolean = false
  constructor(private router: Router, private toster: ToastrService, private httpClient: HttpClient,) {
    const nav = this.router.getCurrentNavigation();
    if (nav?.extras.state) {
      this.imgurl = nav.extras.state['imgUrl']
      this.isApproved = nav.extras.state['isApproved']
    }

  }
  ngOnInit(): void {
    console.log(this.isApproved)
    sessionStorage.setItem('claimedFlag', 'true')
  }
  preloadingFlag: boolean = false
  downLoadQrWeb(flag: boolean = false) {
    if (this.imgurl) {
      if (flag) {
        this.imgurl = this.imgurl.replace('www/qr', 'www/qr/qr_codes');
      }

      const imgName = this.imgurl.substr(this.imgurl.lastIndexOf("/") + 1);
      this.preloadingFlag = true
      this.httpClient
        .get(this.imgurl, { responseType: "blob" as "json" })
        .subscribe((res: any) => {
          const file = new Blob([res], { type: res.type });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file);
            return;
          }
          this.preloadingFlag = false
          const blob = window.URL.createObjectURL(file);
          const link = document.createElement("a");
          link.href = blob;
          link.download = imgName;
          link.dispatchEvent(
            new MouseEvent("click", {
              bubbles: true,
              cancelable: true,
              view: window,
            })
          );
          setTimeout(() => {
            window.URL.revokeObjectURL(blob);
            link.remove();
          }, 100);
        }, err => {
          this.preloadingFlag = false
          this.toster.error('Error downloading QR code', '', { timeOut: 2000 });
        });
    }
  }

  openStore(url: string) {
    window.open(url, "_blank");
  }
}



import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { style } from '@angular/animations';

@Component({
  selector: 'app-claim-buisness-check',
  template: `
    <h2 mat-dialog-title style="font-family: 'Inter', sans-serif;
    font-size: 14px;
    text-align: justify;">{{ data }}</h2>
    <div mat-dialog-actions style="justify-content: center">
      <button type="button" class="btn btn-success" mat-button mat-dialog-close>OK</button>
    </div>
  `,
})
export class DialogClaimCheckComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: string) { }
}